import React, { useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {ArrowLeft, BarChart3, Table as TableIcon, TrendingUp, Search, Filter, FileDown, X, Info} from 'lucide-react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ScatterChart, Scatter } from 'recharts';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

const DataVisualization = () => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState<'table' | 'charts'>('charts');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedXVar, setSelectedXVar] = useState('MICROCUENCA');
  const [selectedYVar, setSelectedYVar] = useState('Erosion');
  const [selectedBarVars, setSelectedBarVars] = useState(['Sup_Agricola', 'Sup_Forestal', 'Sup_Pastizal']);
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedMicrocuenca, setSelectedMicrocuenca] = useState<any | null>(null);
  const [showVariablesInfo, setShowVariablesInfo] = useState(false);

  const allData: any[] = [
  { CODIGO: "23-088-07-002", MUNICIPIO: "Pijijiapan", MICROCUENCA: "El Cerrón", REGION: "Istmo-Costa", Priorizacion: 1, Clase_Priorizacion: "0.551902539439939", Categoria: "Muy Alta", Densidad_Poblacion: 0.02, Rezago_Social: -0.05, Sup_Microcuenca: 5965.61, Sup_Forestal: 5806.07999999999, Sup_Pastizal: 94.7699999999999, Sup_Agricola: 34.8299999999999, Sup_Asentamiento: 18.6299999999999, Sup_Cafe: 33.278, Sup_Incendios: 5.93, Tiempo_Concentracion: 26.68, Pendiente: 40.54, Indice_Gravelius: 1.487, ETP: 35.8, Deforestacion: 0.47, Erosion: 17.22, Escurrimiento: 40, Precipitacion: 220.95 },
  { CODIGO: "30-126-12-005", MUNICIPIO: "Motozintla", MICROCUENCA: "Motozintla De Mendoza", REGION: "Sierra Mariscal", Priorizacion: 2, Clase_Priorizacion: "0.517737485219251", Categoria: "Muy Alta", Densidad_Poblacion: 3.81, Rezago_Social: 0.28, Sup_Microcuenca: 9854.43, Sup_Forestal: 5381.64, Sup_Pastizal: 1912.41, Sup_Agricola: 1434.50999999999, Sup_Asentamiento: 756.539999999999, Sup_Cafe: 4.488, Sup_Incendios: 0.21, Tiempo_Concentracion: 31.95, Pendiente: 41.79, Indice_Gravelius: 1.91, ETP: 40, Deforestacion: 0.18, Erosion: 12.96, Escurrimiento: 37.34, Precipitacion: 145.79 },
  { CODIGO: "23-090-14-002", MUNICIPIO: "Motozintla", MICROCUENCA: "Belisario Domínguez", REGION: "Sierra Mariscal", Priorizacion: 3, Clase_Priorizacion: "0.508974762112395", Categoria: "Muy Alta", Densidad_Poblacion: 1.09, Rezago_Social: 0.28, Sup_Microcuenca: 11383.7, Sup_Forestal: 9225.89999999999, Sup_Pastizal: 1456.38, Sup_Agricola: 187.919999999999, Sup_Asentamiento: 486.81, Sup_Cafe: 6100.81, Sup_Incendios: 0, Tiempo_Concentracion: 37.22, Pendiente: 33.19, Indice_Gravelius: 2.352, ETP: 24.2, Deforestacion: 0, Erosion: 13.85, Escurrimiento: 40, Precipitacion: 334.97 },
  { CODIGO: "23-088-07-003", MUNICIPIO: "Pijijiapan", MICROCUENCA: "Urbina", REGION: "Istmo-Costa", Priorizacion: 4, Clase_Priorizacion: "0.508184858760034", Categoria: "Muy Alta", Densidad_Poblacion: 0.13, Rezago_Social: -0.05, Sup_Microcuenca: 7238.53, Sup_Forestal: 3710.61, Sup_Pastizal: 275.399999999999, Sup_Agricola: 3085.28999999999, Sup_Asentamiento: 134.46, Sup_Cafe: 0, Sup_Incendios: 13.23, Tiempo_Concentracion: 39.49, Pendiente: 18.58, Indice_Gravelius: 2.536, ETP: 39, Deforestacion: 0.3, Erosion: 11.3, Escurrimiento: 33.27, Precipitacion: 202.25 },
  { CODIGO: "23-088-10-002", MUNICIPIO: "Pijijiapan", MICROCUENCA: "Nueva Coapa (Estación Echegaray)", REGION: "Istmo-Costa", Priorizacion: 5, Clase_Priorizacion: "0.506089215991971", Categoria: "Muy Alta", Densidad_Poblacion: 0.25, Rezago_Social: -0.05, Sup_Microcuenca: 10527.23, Sup_Forestal: 4817.06999999999, Sup_Pastizal: 741.149999999999, Sup_Agricola: 4661.55, Sup_Asentamiento: 187.11, Sup_Cafe: 24.087, Sup_Incendios: 9.71, Tiempo_Concentracion: 44.68, Pendiente: 19.58, Indice_Gravelius: 3.442, ETP: 35.1, Deforestacion: 0.61, Erosion: 11.77, Escurrimiento: 30.46, Precipitacion: 204.55 },
  { CODIGO: "23-088-01-001", MUNICIPIO: "Tonalá", MICROCUENCA: "Las Palmas", REGION: "Istmo-Costa", Priorizacion: 6, Clase_Priorizacion: "0.503121673780044", Categoria: "Muy Alta", Densidad_Poblacion: 0.05, Rezago_Social: -0.55, Sup_Microcuenca: 4125.64, Sup_Forestal: 3113.63999999999, Sup_Pastizal: 906.389999999999, Sup_Agricola: 48.6, Sup_Asentamiento: 25.92, Sup_Cafe: 0, Sup_Incendios: 0.05, Tiempo_Concentracion: 23.55, Pendiente: 38.93, Indice_Gravelius: 1.782, ETP: 50.9, Deforestacion: 0.63, Erosion: 14.95, Escurrimiento: 40, Precipitacion: 143.21 },
  { CODIGO: "30-127-15-016", MUNICIPIO: "Villa Corzo", MICROCUENCA: "Monterrey", REGION: "Frailesca", Priorizacion: 7, Clase_Priorizacion: "0.497741086404282", Categoria: "Muy Alta", Densidad_Poblacion: 0.25, Rezago_Social: 0, Sup_Microcuenca: 8404.97, Sup_Forestal: 5929.19999999999, Sup_Pastizal: 699.84, Sup_Agricola: 1645.92, Sup_Asentamiento: 106.92, Sup_Cafe: 0, Sup_Incendios: 3.3, Tiempo_Concentracion: 34.55, Pendiente: 29.94, Indice_Gravelius: 1.741, ETP: 36.6, Deforestacion: 0.13, Erosion: 5.37, Escurrimiento: 18.49, Precipitacion: 161.61 },
  { CODIGO: "23-090-01-001", MUNICIPIO: "Mapastepec", MICROCUENCA: "Solo Dios", REGION: "Istmo-Costa", Priorizacion: 8, Clase_Priorizacion: "0.496708401034636", Categoria: "Muy Alta", Densidad_Poblacion: 0.09, Rezago_Social: -0.06, Sup_Microcuenca: 11294.98, Sup_Forestal: 9102.78, Sup_Pastizal: 405.81, Sup_Agricola: 1688.03999999999, Sup_Asentamiento: 54.27, Sup_Cafe: 320.929, Sup_Incendios: 0, Tiempo_Concentracion: 36.77, Pendiente: 33.95, Indice_Gravelius: 1.782, ETP: 33.9, Deforestacion: 1.1, Erosion: 10.15, Escurrimiento: 40, Precipitacion: 239.68 },
  { CODIGO: "23-090-10-001", MUNICIPIO: "Motozintla", MICROCUENCA: "Miguel Alemán", REGION: "Sierra Mariscal", Priorizacion: 9, Clase_Priorizacion: "0.494045588438921", Categoria: "Muy Alta", Densidad_Poblacion: 0.57, Rezago_Social: 0.28, Sup_Microcuenca: 24459.57, Sup_Forestal: 18728.8199999999, Sup_Pastizal: 3228.65999999999, Sup_Agricola: 1568.16, Sup_Asentamiento: 607.5, Sup_Cafe: 9442.089, Sup_Incendios: 0, Tiempo_Concentracion: 49.14, Pendiente: 34.56, Indice_Gravelius: 3.603, ETP: 29.6, Deforestacion: 0.02, Erosion: 14.14, Escurrimiento: 38.69, Precipitacion: 253.97 },
  { CODIGO: "23-091-05-001", MUNICIPIO: "Tapachula", MICROCUENCA: "Veinte De Noviembre", REGION: "Soconusco", Priorizacion: 10, Clase_Priorizacion: "0.491478215072683", Categoria: "Muy Alta", Densidad_Poblacion: 2.56, Rezago_Social: -0.41, Sup_Microcuenca: 4004.53, Sup_Forestal: 963.09, Sup_Pastizal: 37.2599999999999, Sup_Agricola: 2741.03999999999, Sup_Asentamiento: 257.579999999999, Sup_Cafe: 535.923, Sup_Incendios: 0, Tiempo_Concentracion: 37.41, Pendiente: 11.91, Indice_Gravelius: 6.226, ETP: 39.8, Deforestacion: 0.47, Erosion: 8.02, Escurrimiento: 35.32, Precipitacion: 199.06 },
  { CODIGO: "23-091-02-001", MUNICIPIO: "Tapachula", MICROCUENCA: "Zaragoza", REGION: "Soconusco", Priorizacion: 11, Clase_Priorizacion: "0.47845846359702", Categoria: "Muy Alta", Densidad_Poblacion: 0.61, Rezago_Social: -0.41, Sup_Microcuenca: 12269.45, Sup_Forestal: 11112.3899999999, Sup_Pastizal: 442.259999999999, Sup_Agricola: 381.509999999999, Sup_Asentamiento: 272.97, Sup_Cafe: 5340.885, Sup_Incendios: 0, Tiempo_Concentracion: 35.31, Pendiente: 40.3, Indice_Gravelius: 2.192, ETP: 25.5, Deforestacion: 0.11, Erosion: 12.63, Escurrimiento: 40, Precipitacion: 282.64 },
  { CODIGO: "23-091-05-003", MUNICIPIO: "Huehuetán", MICROCUENCA: "Álvaro Obregón", REGION: "Soconusco", Priorizacion: 12, Clase_Priorizacion: "0.467074831500557", Categoria: "Muy Alta", Densidad_Poblacion: 1.69, Rezago_Social: 0.18, Sup_Microcuenca: 7593.04, Sup_Forestal: 162.81, Sup_Pastizal: 58.32, Sup_Agricola: 6857.46, Sup_Asentamiento: 459.269999999999, Sup_Cafe: 148.702, Sup_Incendios: 0, Tiempo_Concentracion: 54.82, Pendiente: 8.4, Indice_Gravelius: 2.166, ETP: 32.7, Deforestacion: 0.14, Erosion: 6.41, Escurrimiento: 32.42, Precipitacion: 193.04 },
  { CODIGO: "23-089-05-002", MUNICIPIO: "Arriaga", MICROCUENCA: "La Mica", REGION: "Istmo-Costa", Priorizacion: 13, Clase_Priorizacion: "0.464131844836234", Categoria: "Muy Alta", Densidad_Poblacion: 0.02, Rezago_Social: -0.43, Sup_Microcuenca: 7311.62, Sup_Forestal: 3205.17, Sup_Pastizal: 3811.86, Sup_Agricola: 246.24, Sup_Asentamiento: 35.64, Sup_Cafe: 2.631, Sup_Incendios: 5.13, Tiempo_Concentracion: 32.84, Pendiente: 29.75, Indice_Gravelius: 2.372, ETP: 44.1, Deforestacion: 0.1, Erosion: 19.03, Escurrimiento: 25, Precipitacion: 150.36 },
  { CODIGO: "23-091-02-003", MUNICIPIO: "Tapachula", MICROCUENCA: "Veintiseis De Octubre (El Retiro)", REGION: "Soconusco", Priorizacion: 14, Clase_Priorizacion: "0.456722526465609", Categoria: "Muy Alta", Densidad_Poblacion: 1, Rezago_Social: -0.41, Sup_Microcuenca: 10361.42, Sup_Forestal: 8686.44, Sup_Pastizal: 120.689999999999, Sup_Agricola: 1050.56999999999, Sup_Asentamiento: 490.05, Sup_Cafe: 7433.155, Sup_Incendios: 0, Tiempo_Concentracion: 43.17, Pendiente: 21.35, Indice_Gravelius: 2.563, ETP: 36.1, Deforestacion: 0.49, Erosion: 8.92, Escurrimiento: 39.87, Precipitacion: 243.37 },
  { CODIGO: "30-128-09-006", MUNICIPIO: "Huixtán", MICROCUENCA: "Los Pozos", REGION: "Altos ", Priorizacion: 15, Clase_Priorizacion: "0.452416865950301", Categoria: "Muy Alta", Densidad_Poblacion: 1.16, Rezago_Social: 1.88, Sup_Microcuenca: 4035.2, Sup_Forestal: 1155.86999999999, Sup_Pastizal: 22.68, Sup_Agricola: 2630.88, Sup_Asentamiento: 140.939999999999, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 30.82, Pendiente: 19.68, Indice_Gravelius: 3.057, ETP: 71, Deforestacion: 0.25, Erosion: 11.24, Escurrimiento: 23.21, Precipitacion: 94.28 },
  { CODIGO: "23-090-09-002", MUNICIPIO: "Escuintla", MICROCUENCA: "El Triunfo", REGION: "Soconusco", Priorizacion: 16, Clase_Priorizacion: "0.45237557898918", Categoria: "Muy Alta", Densidad_Poblacion: 1, Rezago_Social: 0.15, Sup_Microcuenca: 12384.17, Sup_Forestal: 6246.72, Sup_Pastizal: 3391.46999999999, Sup_Agricola: 1927.79999999999, Sup_Asentamiento: 450.36, Sup_Cafe: 3159.445, Sup_Incendios: 0, Tiempo_Concentracion: 42.28, Pendiente: 26.3, Indice_Gravelius: 2.985, ETP: 27.7, Deforestacion: 0.01, Erosion: 2.71, Escurrimiento: 11.09, Precipitacion: 267.05 },
  { CODIGO: "30-126-04-022", MUNICIPIO: "Villa Corzo", MICROCUENCA: "Plan De Ayala", REGION: "Frailesca", Priorizacion: 17, Clase_Priorizacion: "0.449652814186736", Categoria: "Alta", Densidad_Poblacion: 0, Rezago_Social: 0.23, Sup_Microcuenca: 4289.12, Sup_Forestal: 4032.17999999999, Sup_Pastizal: 101.25, Sup_Agricola: 154.71, Sup_Asentamiento: 3.24, Sup_Cafe: 13.175, Sup_Incendios: 0, Tiempo_Concentracion: 22.07, Pendiente: 46.77, Indice_Gravelius: 2.166, ETP: 31.9, Deforestacion: 0, Erosion: 4.14, Escurrimiento: 40, Precipitacion: 209.54 },
  { CODIGO: "30-127-15-014", MUNICIPIO: "Villa Corzo", MICROCUENCA: "Los Amates", REGION: "Frailesca", Priorizacion: 18, Clase_Priorizacion: "0.439220783822289", Categoria: "Alta", Densidad_Poblacion: 0.08, Rezago_Social: 0.23, Sup_Microcuenca: 9386.74, Sup_Forestal: 8728.55999999999, Sup_Pastizal: 126.359999999999, Sup_Agricola: 418.769999999999, Sup_Asentamiento: 76.95, Sup_Cafe: 249.619, Sup_Incendios: 8.99, Tiempo_Concentracion: 33.84, Pendiente: 34.91, Indice_Gravelius: 1.846, ETP: 45.8, Deforestacion: 0.09, Erosion: 12.28, Escurrimiento: 40, Precipitacion: 146.39 },
  { CODIGO: "30-127-12-030", MUNICIPIO: "Venustiano Carranza", MICROCUENCA: "Presidente Echeverría (Laja Tendida)", REGION: "Los Llanos ", Priorizacion: 19, Clase_Priorizacion: "0.437514233833538", Categoria: "Alta", Densidad_Poblacion: 0.63, Rezago_Social: 0.54, Sup_Microcuenca: 8937.47, Sup_Forestal: 1667.78999999999, Sup_Pastizal: 239.759999999999, Sup_Agricola: 6764.31, Sup_Asentamiento: 240.569999999999, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 50.74, Pendiente: 12.04, Indice_Gravelius: 2.325, ETP: 38.6, Deforestacion: 0.03, Erosion: 16.13, Escurrimiento: 14.86, Precipitacion: 119.38 },
  { CODIGO: "30-127-12-029", MUNICIPIO: "Venustiano Carranza", MICROCUENCA: "Ricardo Flores Magón", REGION: "Los Llanos ", Priorizacion: 20, Clase_Priorizacion: "0.431841664772822", Categoria: "Alta", Densidad_Poblacion: 1.04, Rezago_Social: 0.54, Sup_Microcuenca: 5256.79, Sup_Forestal: 303.75, Sup_Pastizal: 319.949999999999, Sup_Agricola: 4488.21, Sup_Asentamiento: 145.8, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 47.55, Pendiente: 8.41, Indice_Gravelius: 2.425, ETP: 41, Deforestacion: 0, Erosion: 16.56, Escurrimiento: 11.02, Precipitacion: 107.19 },
  { CODIGO: "30-127-06-003", MUNICIPIO: "Ixtapa", MICROCUENCA: "Ixtapa", REGION: "Metropolitana", Priorizacion: 21, Clase_Priorizacion: "0.428751326968416", Categoria: "Alta", Densidad_Poblacion: 1.68, Rezago_Social: 0.66, Sup_Microcuenca: 9522.48, Sup_Forestal: 4523.85, Sup_Pastizal: 405.81, Sup_Agricola: 3396.32999999999, Sup_Asentamiento: 298.079999999999, Sup_Cafe: 97.119, Sup_Incendios: 3.81, Tiempo_Concentracion: 39.47, Pendiente: 24.27, Indice_Gravelius: 3.053, ETP: 61.6, Deforestacion: 0.43, Erosion: 18.16, Escurrimiento: 12.74, Precipitacion: 109.01 },
  { CODIGO: "23-090-18-001", MUNICIPIO: "Tuzantán", MICROCUENCA: "Tuzantán", REGION: "Soconusco", Priorizacion: 22, Clase_Priorizacion: "0.427014187268033", Categoria: "Alta", Densidad_Poblacion: 1.53, Rezago_Social: 0.03, Sup_Microcuenca: 20397.02, Sup_Forestal: 12556.62, Sup_Pastizal: 1692.9, Sup_Agricola: 4655.06999999999, Sup_Asentamiento: 1351.89, Sup_Cafe: 6312.627, Sup_Incendios: 0, Tiempo_Concentracion: 58.74, Pendiente: 18.67, Indice_Gravelius: 2.018, ETP: 27.6, Deforestacion: 0.2, Erosion: 9.91, Escurrimiento: 31.96, Precipitacion: 292.91 },
  { CODIGO: "23-091-06-001", MUNICIPIO: "Tapachula", MICROCUENCA: "El Chaparrón", REGION: "Soconusco", Priorizacion: 23, Clase_Priorizacion: "0.42455536549753", Categoria: "Alta", Densidad_Poblacion: 29.13, Rezago_Social: -0.41, Sup_Microcuenca: 7648.31, Sup_Forestal: 2233.17, Sup_Pastizal: 733.86, Sup_Agricola: 3012.38999999999, Sup_Asentamiento: 1616.75999999999, Sup_Cafe: 1503.316, Sup_Incendios: 0, Tiempo_Concentracion: 51.65, Pendiente: 9.87, Indice_Gravelius: 4.715, ETP: 35.5, Deforestacion: 0.34, Erosion: 6.02, Escurrimiento: 30.36, Precipitacion: 202.45 },
  { CODIGO: "30-127-15-019", MUNICIPIO: "Villa Corzo", MICROCUENCA: "Tierra Santa", REGION: "Frailesca", Priorizacion: 24, Clase_Priorizacion: "0.418158020899722", Categoria: "Alta", Densidad_Poblacion: 0.16, Rezago_Social: 0.23, Sup_Microcuenca: 4248.62, Sup_Forestal: 3674.15999999999, Sup_Pastizal: 356.399999999999, Sup_Agricola: 208.169999999999, Sup_Asentamiento: 0, Sup_Cafe: 81.64, Sup_Incendios: 0.26, Tiempo_Concentracion: 24.2, Pendiente: 37.5, Indice_Gravelius: 1.467, ETP: 42.2, Deforestacion: 0, Erosion: 11.59, Escurrimiento: 39.98, Precipitacion: 169.89 },
  { CODIGO: "23-089-05-005", MUNICIPIO: "Arriaga", MICROCUENCA: "Poza Galana", REGION: "Istmo-Costa", Priorizacion: 25, Clase_Priorizacion: "0.407531019145843", Categoria: "Alta", Densidad_Poblacion: 0.02, Rezago_Social: -0.43, Sup_Microcuenca: 4102.97, Sup_Forestal: 2921.67, Sup_Pastizal: 991.44, Sup_Agricola: 139.319999999999, Sup_Asentamiento: 33.21, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 51.67, Pendiente: 37.25, Indice_Gravelius: 1.803, ETP: 52.8, Deforestacion: 0.34, Erosion: 17.33, Escurrimiento: 25.33, Precipitacion: 144.75 },
  { CODIGO: "30-127-14-020", MUNICIPIO: "Villaflores", MICROCUENCA: "Tres Picos", REGION: "Frailesca", Priorizacion: 26, Clase_Priorizacion: "0.403555478777201", Categoria: "Alta", Densidad_Poblacion: 0.12, Rezago_Social: -0.25, Sup_Microcuenca: 8708.09, Sup_Forestal: 7949.34, Sup_Pastizal: 56.7, Sup_Agricola: 652.86, Sup_Asentamiento: 8.91, Sup_Cafe: 101.191, Sup_Incendios: 41.02, Tiempo_Concentracion: 33.93, Pendiente: 32.35, Indice_Gravelius: 2.321, ETP: 48.7, Deforestacion: 0.07, Erosion: 7.38, Escurrimiento: 35.07, Precipitacion: 133.77 },
  { CODIGO: "30-127-14-021", MUNICIPIO: "Villaflores", MICROCUENCA: "Los Ángeles", REGION: "Frailesca", Priorizacion: 27, Clase_Priorizacion: "0.403399938671026", Categoria: "Alta", Densidad_Poblacion: 0.23, Rezago_Social: -0.25, Sup_Microcuenca: 8744.05, Sup_Forestal: 6625.8, Sup_Pastizal: 670.679999999999, Sup_Agricola: 1291.95, Sup_Asentamiento: 132.84, Sup_Cafe: 0.874, Sup_Incendios: 25.29, Tiempo_Concentracion: 34.81, Pendiente: 30.53, Indice_Gravelius: 1.804, ETP: 47.8, Deforestacion: 0.08, Erosion: 10.01, Escurrimiento: 32.43, Precipitacion: 132.73 },
  { CODIGO: "30-128-03-006", MUNICIPIO: "Chenalhó", MICROCUENCA: "Chalam", REGION: "Altos ", Priorizacion: 28, Clase_Priorizacion: "0.402954050477425", Categoria: "Alta", Densidad_Poblacion: 3.1, Rezago_Social: 2.88, Sup_Microcuenca: 9921.42, Sup_Forestal: 4072.67999999999, Sup_Pastizal: 61.56, Sup_Agricola: 4918.31999999999, Sup_Asentamiento: 699.029999999999, Sup_Cafe: 1341.426, Sup_Incendios: 0, Tiempo_Concentracion: 39.05, Pendiente: 25.93, Indice_Gravelius: 2.364, ETP: 51.3, Deforestacion: 0.27, Erosion: 7.8, Escurrimiento: 23.22, Precipitacion: 159.42 },
  { CODIGO: "23-090-01-002", MUNICIPIO: "Mapastepec", MICROCUENCA: "Tres De Mayo", REGION: "Istmo-Costa", Priorizacion: 29, Clase_Priorizacion: "0.402209477346862", Categoria: "Alta", Densidad_Poblacion: 0.07, Rezago_Social: -0.06, Sup_Microcuenca: 8076.64, Sup_Forestal: 7690.14, Sup_Pastizal: 39.6899999999999, Sup_Agricola: 304.56, Sup_Asentamiento: 29.9699999999999, Sup_Cafe: 196.648, Sup_Incendios: 0, Tiempo_Concentracion: 29.74, Pendiente: 41.31, Indice_Gravelius: 1.882, ETP: 32, Deforestacion: 0.01, Erosion: 11.02, Escurrimiento: 40, Precipitacion: 244.04 },
  { CODIGO: "30-126-08-009", MUNICIPIO: "La Concordia", MICROCUENCA: "Las Joyas", REGION: "Frailesca", Priorizacion: 30, Clase_Priorizacion: "0.395079158190658", Categoria: "Alta", Densidad_Poblacion: 0.34, Rezago_Social: 0.53, Sup_Microcuenca: 4347.61, Sup_Forestal: 3478.13999999999, Sup_Pastizal: 336.149999999999, Sup_Agricola: 365.31, Sup_Asentamiento: 67.23, Sup_Cafe: 257.541, Sup_Incendios: 0.3, Tiempo_Concentracion: 26.49, Pendiente: 30.83, Indice_Gravelius: 2.466, ETP: 37.6, Deforestacion: 0.28, Erosion: 6.87, Escurrimiento: 36.06, Precipitacion: 199.69 },
  { CODIGO: "23-090-06-001", MUNICIPIO: "Mapastepec", MICROCUENCA: "Sesecapa", REGION: "Istmo-Costa", Priorizacion: 31, Clase_Priorizacion: "0.386763859607117", Categoria: "Alta", Densidad_Poblacion: 0.54, Rezago_Social: -0.06, Sup_Microcuenca: 18691.4, Sup_Forestal: 5059.26, Sup_Pastizal: 12.15, Sup_Agricola: 12721.0499999999, Sup_Asentamiento: 675.539999999999, Sup_Cafe: 430.61, Sup_Incendios: 0, Tiempo_Concentracion: 62.59, Pendiente: 14.57, Indice_Gravelius: 2.125, ETP: 32.5, Deforestacion: 0.08, Erosion: 7.77, Escurrimiento: 25.34, Precipitacion: 214.63 },
  { CODIGO: "23-088-01-003", MUNICIPIO: "Tonalá", MICROCUENCA: "Raymundo Flores Fuente", REGION: "Istmo-Costa", Priorizacion: 32, Clase_Priorizacion: "0.382654149793652", Categoria: "Alta", Densidad_Poblacion: 0.05, Rezago_Social: -0.55, Sup_Microcuenca: 4295.21, Sup_Forestal: 3692.78999999999, Sup_Pastizal: 579.149999999999, Sup_Agricola: 8.91, Sup_Asentamiento: 0.81, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 23.35, Pendiente: 41.19, Indice_Gravelius: 1.635, ETP: 48.5, Deforestacion: 0, Erosion: 8.09, Escurrimiento: 40, Precipitacion: 152.07 },
  { CODIGO: "23-090-18-002", MUNICIPIO: "Huehuetán", MICROCUENCA: "Chamulapa", REGION: "Soconusco", Priorizacion: 33, Clase_Priorizacion: "0.37768433910741", Categoria: "Media", Densidad_Poblacion: 1.1, Rezago_Social: 0.18, Sup_Microcuenca: 6479.01, Sup_Forestal: 1307.33999999999, Sup_Pastizal: 46.9799999999999, Sup_Agricola: 4659.11999999999, Sup_Asentamiento: 395.279999999999, Sup_Cafe: 912.954, Sup_Incendios: 0, Tiempo_Concentracion: 48.84, Pendiente: 9.66, Indice_Gravelius: 4.027, ETP: 31.1, Deforestacion: 0.29, Erosion: 6.79, Escurrimiento: 22.51, Precipitacion: 238.09 },
  { CODIGO: "30-128-09-001", MUNICIPIO: "Chamula", MICROCUENCA: "La Candelaria", REGION: "Altos ", Priorizacion: 34, Clase_Priorizacion: "0.377424121019996", Categoria: "Media", Densidad_Poblacion: 1.68, Rezago_Social: 2.56, Sup_Microcuenca: 8039, Sup_Forestal: 3615.84, Sup_Pastizal: 38.88, Sup_Agricola: 3857.21999999999, Sup_Asentamiento: 497.339999999999, Sup_Cafe: 0.480, Sup_Incendios: 0.02, Tiempo_Concentracion: 40.11, Pendiente: 19.77, Indice_Gravelius: 1.968, ETP: 63.9, Deforestacion: 0.07, Erosion: 11.28, Escurrimiento: 16.52, Precipitacion: 101.96 },
  { CODIGO: "30-126-08-011", MUNICIPIO: "La Concordia", MICROCUENCA: "Valle De Cuxtepeques (El Naranjo)", REGION: "Frailesca", Priorizacion: 35, Clase_Priorizacion: "0.370062279741898", Categoria: "Media", Densidad_Poblacion: 0.24, Rezago_Social: 0.53, Sup_Microcuenca: 10367.01, Sup_Forestal: 9202.40999999999, Sup_Pastizal: 502.199999999999, Sup_Agricola: 424.439999999999, Sup_Asentamiento: 136.08, Sup_Cafe: 1341.757, Sup_Incendios: 0, Tiempo_Concentracion: 33.78, Pendiente: 38.41, Indice_Gravelius: 2.37, ETP: 32, Deforestacion: 0.06, Erosion: 5.6, Escurrimiento: 40, Precipitacion: 222.51 },
  { CODIGO: "30-128-09-003", MUNICIPIO: "Huixtán", MICROCUENCA: "Tzopilja", REGION: "Altos ", Priorizacion: 36, Clase_Priorizacion: "0.357378169200233", Categoria: "Media", Densidad_Poblacion: 0.81, Rezago_Social: 1.88, Sup_Microcuenca: 9108.76, Sup_Forestal: 2793.69, Sup_Pastizal: 349.11, Sup_Agricola: 4273.56, Sup_Asentamiento: 387.18, Sup_Cafe: 0, Sup_Incendios: 1.38, Tiempo_Concentracion: 40.88, Pendiente: 21.29, Indice_Gravelius: 3.142, ETP: 77.6, Deforestacion: 0.22, Erosion: 8.29, Escurrimiento: 18.45, Precipitacion: 91.94 },
  { CODIGO: "30-127-12-002", MUNICIPIO: "Chiapa de Corzo", MICROCUENCA: "Playa Vista", REGION: "Metropolitana", Priorizacion: 37, Clase_Priorizacion: "0.351522676280456", Categoria: "Media", Densidad_Poblacion: 2.02, Rezago_Social: -0.45, Sup_Microcuenca: 6654.4, Sup_Forestal: 2429.19, Sup_Pastizal: 737.909999999999, Sup_Agricola: 1532.51999999999, Sup_Asentamiento: 1291.95, Sup_Cafe: 0, Sup_Incendios: 4.49, Tiempo_Concentracion: 38.67, Pendiente: 18.06, Indice_Gravelius: 2.293, ETP: 56.2, Deforestacion: 0.08, Erosion: 16.45, Escurrimiento: 14.04, Precipitacion: 88.21 },
  { CODIGO: "23-091-04-001", MUNICIPIO: "Cacahoatán", MICROCUENCA: "Cacahoatán", REGION: "Soconusco", Priorizacion: 38, Clase_Priorizacion: "0.351241217677819", Categoria: "Media", Densidad_Poblacion: 4.68, Rezago_Social: -0.22, Sup_Microcuenca: 8600.65, Sup_Forestal: 5665.14, Sup_Pastizal: 204.93, Sup_Agricola: 1733.4, Sup_Asentamiento: 959.85, Sup_Cafe: 4428.749, Sup_Incendios: 0, Tiempo_Concentracion: 44.34, Pendiente: 16.38, Indice_Gravelius: 3.651, ETP: 33.2, Deforestacion: 0.16, Erosion: 4.22, Escurrimiento: 35.39, Precipitacion: 253.6 },
  { CODIGO: "23-091-04-004", MUNICIPIO: "Tuxtla Chico", MICROCUENCA: "Tapachula De Córdova y Ordoñez", REGION: "Soconusco", Priorizacion: 39, Clase_Priorizacion: "0.335631389540701", Categoria: "Media", Densidad_Poblacion: 1.3, Rezago_Social: 0.05, Sup_Microcuenca: 14578.21, Sup_Forestal: 1451.51999999999, Sup_Pastizal: 406.62, Sup_Agricola: 10078.8299999999, Sup_Asentamiento: 2555.55, Sup_Cafe: 498.107, Sup_Incendios: 0, Tiempo_Concentracion: 76.57, Pendiente: 6.77, Indice_Gravelius: 3.721, ETP: 29.1, Deforestacion: 0.13, Erosion: 5.34, Escurrimiento: 20.97, Precipitacion: 197.31 },
  { CODIGO: "30-124-18-018", MUNICIPIO: "Chamula", MICROCUENCA: "Tzajaltetic", REGION: "Altos ", Priorizacion: 40, Clase_Priorizacion: "0.335484452369931", Categoria: "Media", Densidad_Poblacion: 2.82, Rezago_Social: 2.56, Sup_Microcuenca: 11650.84, Sup_Forestal: 5621.39999999999, Sup_Pastizal: 256.769999999999, Sup_Agricola: 4800.06, Sup_Asentamiento: 669.87, Sup_Cafe: 847.768, Sup_Incendios: 0, Tiempo_Concentracion: 42.22, Pendiente: 24.9, Indice_Gravelius: 3.703, ETP: 59.5, Deforestacion: 0.2, Erosion: 3.68, Escurrimiento: 23.77, Precipitacion: 124.38 },
  { CODIGO: "30-127-01-008", MUNICIPIO: "Bochil", MICROCUENCA: "Bochil", REGION: "Lo Bosques", Priorizacion: 41, Clase_Priorizacion: "0.334250754828865", Categoria: "Media", Densidad_Poblacion: 1.69, Rezago_Social: 0.68, Sup_Microcuenca: 20450.82, Sup_Forestal: 7162.02, Sup_Pastizal: 345.87, Sup_Agricola: 6231.32999999999, Sup_Asentamiento: 737.909999999999, Sup_Cafe: 293.374, Sup_Incendios: 0, Tiempo_Concentracion: 48.5, Pendiente: 30.18, Indice_Gravelius: 2.301, ETP: 66.4, Deforestacion: 0.3, Erosion: 8.41, Escurrimiento: 20.38, Precipitacion: 113.75 },
  { CODIGO: "30-127-13-026", MUNICIPIO: "Cintalapa", MICROCUENCA: "Rosendo Salazar", REGION: "Valle Zoque", Priorizacion: 42, Clase_Priorizacion: "0.334000899208151", Categoria: "Media", Densidad_Poblacion: 0.11, Rezago_Social: -0.14, Sup_Microcuenca: 14255.45, Sup_Forestal: 10207.62, Sup_Pastizal: 1314.63, Sup_Agricola: 2410.55999999999, Sup_Asentamiento: 177.389999999999, Sup_Cafe: 176.84, Sup_Incendios: 10.68, Tiempo_Concentracion: 49.15, Pendiente: 20.66, Indice_Gravelius: 2.151, ETP: 56.1, Deforestacion: 0.77, Erosion: 8.15, Escurrimiento: 23.49, Precipitacion: 127.54 },
  { CODIGO: "30-127-13-023", MUNICIPIO: "Jiquipilas", MICROCUENCA: "José María Pino Suarez", REGION: "Valle Zoque", Priorizacion: 43, Clase_Priorizacion: "0.322270115353914", Categoria: "Media", Densidad_Poblacion: 0.47, Rezago_Social: -0.12, Sup_Microcuenca: 6506.7, Sup_Forestal: 2387.88, Sup_Pastizal: 225.18, Sup_Agricola: 3768.11999999999, Sup_Asentamiento: 127.17, Sup_Cafe: 2.105, Sup_Incendios: 7.15, Tiempo_Concentracion: 42.26, Pendiente: 14.07, Indice_Gravelius: 4.402, ETP: 52.9, Deforestacion: 0.17, Erosion: 6.97, Escurrimiento: 16.48, Precipitacion: 96.86 },
  { CODIGO: "30-126-04-023", MUNICIPIO: "Villa Corzo", MICROCUENCA: "Plan De Ayala", REGION: "Frailesca", Priorizacion: 44, Clase_Priorizacion: "0.305356599427601", Categoria: "Media", Densidad_Poblacion: 0.07, Rezago_Social: 0.23, Sup_Microcuenca: 3967.03, Sup_Forestal: 3879.09, Sup_Pastizal: 48.6, Sup_Agricola: 42.1199999999999, Sup_Asentamiento: 0, Sup_Cafe: 64.330, Sup_Incendios: 0, Tiempo_Concentracion: 22.05, Pendiente: 44.5, Indice_Gravelius: 1.931, ETP: 29.8, Deforestacion: 0.47, Erosion: 12.87, Escurrimiento: 40, Precipitacion: 213.85 },
  { CODIGO: "23-089-07-003", MUNICIPIO: "Tonalá", MICROCUENCA: "Tonalá", REGION: "Istmo-Costa", Priorizacion: 45, Clase_Priorizacion: "0.305133927910537", Categoria: "Media", Densidad_Poblacion: 2.28, Rezago_Social: -0.55, Sup_Microcuenca: 20831.17, Sup_Forestal: 3896.09999999999, Sup_Pastizal: 13606.3799999999, Sup_Agricola: 1869.48, Sup_Asentamiento: 1379.43, Sup_Cafe: 1.9, Sup_Incendios: 3.59, Tiempo_Concentracion: 71.62, Pendiente: 11.48, Indice_Gravelius: 2.208, ETP: 48.1, Deforestacion: 0.05, Erosion: 4.65, Escurrimiento: 19.49, Precipitacion: 127.89 },
  { CODIGO: "30-127-13-028", MUNICIPIO: "Jiquipilas", MICROCUENCA: "Julian Grajales", REGION: "Valle Zoque", Priorizacion: 46, Clase_Priorizacion: "0.299549992123286", Categoria: "Media", Densidad_Poblacion: 0.23, Rezago_Social: -0.12, Sup_Microcuenca: 10336.62, Sup_Forestal: 6457.31999999999, Sup_Pastizal: 313.47, Sup_Agricola: 3332.34, Sup_Asentamiento: 218.699999999999, Sup_Cafe: 61.613, Sup_Incendios: 10.36, Tiempo_Concentracion: 42.67, Pendiente: 21.61, Indice_Gravelius: 2.282, ETP: 52, Deforestacion: 0.45, Erosion: 4.17, Escurrimiento: 23.84, Precipitacion: 122.87 },
  { CODIGO: "30-128-10-002", MUNICIPIO: "Chanal", MICROCUENCA: "Natiltón", REGION: "Altos ", Priorizacion: 47, Clase_Priorizacion: "0.284294306171843", Categoria: "Media", Densidad_Poblacion: 0.19, Rezago_Social: 2.45, Sup_Microcuenca: 9386.23, Sup_Forestal: 2127.86999999999, Sup_Pastizal: 110.969999999999, Sup_Agricola: 1370.51999999999, Sup_Asentamiento: 42.1199999999999, Sup_Cafe: 0, Sup_Incendios: 17.75, Tiempo_Concentracion: 43.24, Pendiente: 19.02, Indice_Gravelius: 2.506, ETP: 88.7, Deforestacion: 2.37, Erosion: 2.5, Escurrimiento: 7.51, Precipitacion: 83.45 },
  { CODIGO: "30-128-09-004", MUNICIPIO: "Oxchuc", MICROCUENCA: "Conoilja", REGION: "Altos ", Priorizacion: 48, Clase_Priorizacion: "0.282609198291277", Categoria: "Baja", Densidad_Poblacion: 0.44, Rezago_Social: 3.38, Sup_Microcuenca: 9090.89, Sup_Forestal: 2549.07, Sup_Pastizal: 401.759999999999, Sup_Agricola: 1760.13, Sup_Asentamiento: 176.58, Sup_Cafe: 0.5, Sup_Incendios: 5.34, Tiempo_Concentracion: 35.87, Pendiente: 29.43, Indice_Gravelius: 2.974, ETP: 90.9, Deforestacion: 0.91, Erosion: 5.12, Escurrimiento: 10.36, Precipitacion: 87.54 },
  { CODIGO: "23-089-05-001", MUNICIPIO: "Arriaga", MICROCUENCA: "Monte Bonito", REGION: "Istmo-Costa", Priorizacion: 49, Clase_Priorizacion: "0.280738572601776", Categoria: "Baja", Densidad_Poblacion: 0.01, Rezago_Social: -0.43, Sup_Microcuenca: 5091.73, Sup_Forestal: 3738.15, Sup_Pastizal: 1190.7, Sup_Agricola: 16.1999999999999, Sup_Asentamiento: 133.65, Sup_Cafe: 23.491, Sup_Incendios: 6.44, Tiempo_Concentracion: 27.52, Pendiente: 32.58, Indice_Gravelius: 2.119, ETP: 41.7, Deforestacion: 0, Erosion: 8.4, Escurrimiento: 25, Precipitacion: 186.09 },
  { CODIGO: "23-091-06-002", MUNICIPIO: "Mazatán", MICROCUENCA: "El Aguacate", REGION: "Soconusco", Priorizacion: 50, Clase_Priorizacion: "0.280324746242004", Categoria: "Baja", Densidad_Poblacion: 0.55, Rezago_Social: 0.06, Sup_Microcuenca: 8249.22, Sup_Forestal: 0, Sup_Pastizal: 151.469999999999, Sup_Agricola: 7749.27, Sup_Asentamiento: 311.85, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 78.78, Pendiente: 3.57, Indice_Gravelius: 2.02, ETP: 29.4, Deforestacion: 0.05, Erosion: 2.48, Escurrimiento: 15, Precipitacion: 167.34 },
  { CODIGO: "30-128-13-002", MUNICIPIO: "Las Margaritas", MICROCUENCA: "Chiapas", REGION: "Meseta Comiteca", Priorizacion: 51, Clase_Priorizacion: "0.27929376843843", Categoria: "Baja", Densidad_Poblacion: 0.38, Rezago_Social: 1.6, Sup_Microcuenca: 14792.59, Sup_Forestal: 6128.46, Sup_Pastizal: 273.779999999999, Sup_Agricola: 2670.57, Sup_Asentamiento: 394.47, Sup_Cafe: 184.662, Sup_Incendios: 0.24, Tiempo_Concentracion: 47.28, Pendiente: 26.62, Indice_Gravelius: 3.323, ETP: 71.8, Deforestacion: 0.09, Erosion: 5.38, Escurrimiento: 20.62, Precipitacion: 105.04 },
  { CODIGO: "23-091-05-005", MUNICIPIO: "Mazatán", MICROCUENCA: "Aquiles Serdán", REGION: "Soconusco", Priorizacion: 52, Clase_Priorizacion: "0.270789566765315", Categoria: "Baja", Densidad_Poblacion: 0.59, Rezago_Social: 0.06, Sup_Microcuenca: 7413.32, Sup_Forestal: 0, Sup_Pastizal: 229.229999999999, Sup_Agricola: 6840.44999999999, Sup_Asentamiento: 294.839999999999, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 76.53, Pendiente: 3.44, Indice_Gravelius: 2.688, ETP: 29.6, Deforestacion: 0, Erosion: 2.46, Escurrimiento: 14.22, Precipitacion: 174.95 },
  { CODIGO: "30-127-13-031", MUNICIPIO: "Jiquipilas", MICROCUENCA: "Tierra Y Libertad", REGION: "Valle Zoque", Priorizacion: 53, Clase_Priorizacion: "0.261060994969786", Categoria: "Baja", Densidad_Poblacion: 0.6, Rezago_Social: -0.12, Sup_Microcuenca: 8919.4, Sup_Forestal: 4923.98999999999, Sup_Pastizal: 473.85, Sup_Agricola: 3110.4, Sup_Asentamiento: 383.939999999999, Sup_Cafe: 126.469, Sup_Incendios: 0.27, Tiempo_Concentracion: 42.97, Pendiente: 18.39, Indice_Gravelius: 1.699, ETP: 45.5, Deforestacion: 0.02, Erosion: 4.75, Escurrimiento: 24.09, Precipitacion: 135.2 },
  { CODIGO: "23-091-05-004", MUNICIPIO: "Mazatán", MICROCUENCA: "Mazatán", REGION: "Soconusco", Priorizacion: 54, Clase_Priorizacion: "0.259680793013803", Categoria: "Baja", Densidad_Poblacion: 1.65, Rezago_Social: 0.06, Sup_Microcuenca: 10704.91, Sup_Forestal: 0, Sup_Pastizal: 572.669999999999, Sup_Agricola: 8590.04999999999, Sup_Asentamiento: 839.159999999999, Sup_Cafe: 0, Sup_Incendios: 0.67, Tiempo_Concentracion: 109.9, Pendiente: 3.2, Indice_Gravelius: 3.647, ETP: 31.4, Deforestacion: 0, Erosion: 2.39, Escurrimiento: 16.46, Precipitacion: 156.42 },
  { CODIGO: "30-128-15-001", MUNICIPIO: "Comitán de Domínguez", MICROCUENCA: "San José Las Rosas", REGION: "Meseta Comiteca", Priorizacion: 55, Clase_Priorizacion: "0.257311442981686", Categoria: "Baja", Densidad_Poblacion: 0.21, Rezago_Social: -0.28, Sup_Microcuenca: 6996.67, Sup_Forestal: 3524.30999999999, Sup_Pastizal: 0, Sup_Agricola: 1603.79999999999, Sup_Asentamiento: 90.7199999999999, Sup_Cafe: 0.3, Sup_Incendios: 0.06, Tiempo_Concentracion: 40.28, Pendiente: 17.08, Indice_Gravelius: 5.606, ETP: 82.3, Deforestacion: 1.74, Erosion: 6.16, Escurrimiento: 7.5, Precipitacion: 83.19 },
  { CODIGO: "30-126-03-001", MUNICIPIO: "Amatenango del Valle", MICROCUENCA: "Aguacatenango", REGION: "Altos ", Priorizacion: 56, Clase_Priorizacion: "0.243803948351933", Categoria: "Baja", Densidad_Poblacion: 0.78, Rezago_Social: 2.32, Sup_Microcuenca: 9960.02, Sup_Forestal: 3248.90999999999, Sup_Pastizal: 938.789999999999, Sup_Agricola: 2651.94, Sup_Asentamiento: 377.459999999999, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 45.36, Pendiente: 17.85, Indice_Gravelius: 2.614, ETP: 62.4, Deforestacion: 0.6, Erosion: 5.66, Escurrimiento: 7.72, Precipitacion: 9.95 },
  { CODIGO: "30-128-13-001", MUNICIPIO: "Las Margaritas", MICROCUENCA: "Gabriel Leyva Velázquez", REGION: "Meseta Comiteca", Priorizacion: 57, Clase_Priorizacion: "0.235686384366849", Categoria: "Baja", Densidad_Poblacion: 0.17, Rezago_Social: 1.6, Sup_Microcuenca: 13680.41, Sup_Forestal: 8479.07999999999, Sup_Pastizal: 63.99, Sup_Agricola: 1241.73, Sup_Asentamiento: 51.03, Sup_Cafe: 80.646, Sup_Incendios: 10.01, Tiempo_Concentracion: 45.74, Pendiente: 23.8, Indice_Gravelius: 3.838, ETP: 64.8, Deforestacion: 0.2, Erosion: 2.5, Escurrimiento: 18.17, Precipitacion: 110.72 },
  { CODIGO: "30-128-18-002", MUNICIPIO: "La Independencia", MICROCUENCA: "Venustiano Carranza", REGION: "Meseta Comiteca", Priorizacion: 58, Clase_Priorizacion: "0.23219421683377", Categoria: "Baja", Densidad_Poblacion: 0.99, Rezago_Social: 0.77, Sup_Microcuenca: 32318.35, Sup_Forestal: 5854.68, Sup_Pastizal: 4991.22, Sup_Agricola: 16992.99, Sup_Asentamiento: 1909.98, Sup_Cafe: 0.25, Sup_Incendios: 2.09, Tiempo_Concentracion: 104.92, Pendiente: 6.61, Indice_Gravelius: 3.75, ETP: 64.1, Deforestacion: 0.04, Erosion: 3.29, Escurrimiento: 10.54, Precipitacion: 88.76 },
  { CODIGO: "30-127-02-019", MUNICIPIO: "San Fernando", MICROCUENCA: "Monterrey", REGION: "Metropolitana", Priorizacion: 59, Clase_Priorizacion: "0.231088145930216", Categoria: "Baja", Densidad_Poblacion: 0.41, Rezago_Social: 0.23, Sup_Microcuenca: 8730.14, Sup_Forestal: 3116.07, Sup_Pastizal: 733.86, Sup_Agricola: 3889.61999999999, Sup_Asentamiento: 102.87, Sup_Cafe: 476.602, Sup_Incendios: 22.92, Tiempo_Concentracion: 33.6, Pendiente: 26.95, Indice_Gravelius: 2.895, ETP: 62.5, Deforestacion: 0.31, Erosion: 9.24, Escurrimiento: 36.03, Precipitacion: 102.08 },
  { CODIGO: "30-126-01-004", MUNICIPIO: "Las Rosas", MICROCUENCA: "Corral Hierba", REGION: "Meseta Comiteca", Priorizacion: 60, Clase_Priorizacion: "0.218810592223738", Categoria: "Baja", Densidad_Poblacion: 0.33, Rezago_Social: 1.05, Sup_Microcuenca: 10201.15, Sup_Forestal: 2854.44, Sup_Pastizal: 38.07, Sup_Agricola: 4435.56, Sup_Asentamiento: 264.06, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 46.64, Pendiente: 17.02, Indice_Gravelius: 3.95, ETP: 52.3, Deforestacion: 0.05, Erosion: 6.71, Escurrimiento: 7.5, Precipitacion: 98.11 },
  { CODIGO: "30-127-01-011", MUNICIPIO: "Chiapa de Corzo", MICROCUENCA: "Gabriel Esquinca", REGION: "Metropolitana", Priorizacion: 61, Clase_Priorizacion: "0.214615589906176", Categoria: "Baja", Densidad_Poblacion: 0.71, Rezago_Social: -0.45, Sup_Microcuenca: 22367.9, Sup_Forestal: 11041.92, Sup_Pastizal: 2263.94999999999, Sup_Agricola: 4357.8, Sup_Asentamiento: 414.72, Sup_Cafe: 350.803, Sup_Incendios: 0, Tiempo_Concentracion: 46.86, Pendiente: 35.66, Indice_Gravelius: 6.447, ETP: 67.8, Deforestacion: 0.35, Erosion: 8.2, Escurrimiento: 11.96, Precipitacion: 99.67 },
  { CODIGO: "30-127-09-001", MUNICIPIO: "Chamula", MICROCUENCA: "Yaltem", REGION: "Altos ", Priorizacion: 62, Clase_Priorizacion: "0.2127704434094", Categoria: "Baja", Densidad_Poblacion: 0.97, Rezago_Social: 2.56, Sup_Microcuenca: 8494, Sup_Forestal: 5964.84, Sup_Pastizal: 152.28, Sup_Agricola: 1127.51999999999, Sup_Asentamiento: 320.759999999999, Sup_Cafe: 14.53, Sup_Incendios: 0.62, Tiempo_Concentracion: 34.36, Pendiente: 30.66, Indice_Gravelius: 2.389, ETP: 53.7, Deforestacion: 0.12, Erosion: 7.25, Escurrimiento: 7.57, Precipitacion: 116.51 },
  { CODIGO: "30-127-14-001", MUNICIPIO: "Ocozocoautla de Espinosa", MICROCUENCA: "Vicente Guerrero (Matamoros)", REGION: "Valle Zoque", Priorizacion: 63, Clase_Priorizacion: "0.209271238517863", Categoria: "Baja", Densidad_Poblacion: 0.23, Rezago_Social: 0.17, Sup_Microcuenca: 21275.88, Sup_Forestal: 9506.96999999999, Sup_Pastizal: 3421.44, Sup_Agricola: 7952.57999999999, Sup_Asentamiento: 324, Sup_Cafe: 0, Sup_Incendios: 0.81, Tiempo_Concentracion: 61.45, Pendiente: 17.34, Indice_Gravelius: 3.577, ETP: 51, Deforestacion: 0.26, Erosion: 4.18, Escurrimiento: 8.65, Precipitacion: 91.74 },
  { CODIGO: "30-127-10-001", MUNICIPIO: "Chamula", MICROCUENCA: "Chamula", REGION: "Altos ", Priorizacion: 64, Clase_Priorizacion: "0.205930791258419", Categoria: "Muy Baja", Densidad_Poblacion: 3.48, Rezago_Social: 2.56, Sup_Microcuenca: 10250.86, Sup_Forestal: 5107.05, Sup_Pastizal: 34.02, Sup_Agricola: 3078, Sup_Asentamiento: 1964.25, Sup_Cafe: 0, Sup_Incendios: 0.02, Tiempo_Concentracion: 43.16, Pendiente: 20.82, Indice_Gravelius: 3.217, ETP: 59.9, Deforestacion: 0.13, Erosion: 4.65, Escurrimiento: 8.14, Precipitacion: 103.29 },
  { CODIGO: "30-127-08-003", MUNICIPIO: "Tuxtla Gutiérrez", MICROCUENCA: "Tuxtla Gutiérrez", REGION: "Metropolitana", Priorizacion: 65, Clase_Priorizacion: "0.203528414039947", Categoria: "Muy Baja", Densidad_Poblacion: 48.05, Rezago_Social: -1.07, Sup_Microcuenca: 12321.56, Sup_Forestal: 4471.19999999999, Sup_Pastizal: 1142.91, Sup_Agricola: 1049.75999999999, Sup_Asentamiento: 5606.81999999999, Sup_Cafe: 40.719, Sup_Incendios: 2.08, Tiempo_Concentracion: 52.71, Pendiente: 14.99, Indice_Gravelius: 2.013, ETP: 57.7, Deforestacion: 0.28, Erosion: 1.41, Escurrimiento: 16.12, Precipitacion: 83.64 },
  { CODIGO: "30-126-05-008", MUNICIPIO: "La Trinitaria", MICROCUENCA: "Chihuahua", REGION: "Meseta Comiteca", Priorizacion: 66, Clase_Priorizacion: "0.200310510763878", Categoria: "Muy Baja", Densidad_Poblacion: 0.32, Rezago_Social: 0.47, Sup_Microcuenca: 5768.61, Sup_Forestal: 2624.4, Sup_Pastizal: 714.419999999999, Sup_Agricola: 1378.61999999999, Sup_Asentamiento: 149.039999999999, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 37.97, Pendiente: 16.45, Indice_Gravelius: 1.689, ETP: 56.5, Deforestacion: 0.23, Erosion: 3.02, Escurrimiento: 12.46, Precipitacion: 98.06 },
  { CODIGO: "30-126-07-003", MUNICIPIO: "La Trinitaria", MICROCUENCA: "Ángel Albino Corzo", REGION: "Meseta Comiteca", Priorizacion: 67, Clase_Priorizacion: "0.19983242730205", Categoria: "Muy Baja", Densidad_Poblacion: 0.17, Rezago_Social: 0.47, Sup_Microcuenca: 5604.79, Sup_Forestal: 2673.80999999999, Sup_Pastizal: 562.139999999999, Sup_Agricola: 1004.39999999999, Sup_Asentamiento: 79.3799999999999, Sup_Cafe: 0, Sup_Incendios: 5.16, Tiempo_Concentracion: 34.07, Pendiente: 21.03, Indice_Gravelius: 2.192, ETP: 57.2, Deforestacion: 0, Erosion: 2.78, Escurrimiento: 14.5, Precipitacion: 98.61 },
  { CODIGO: "30-128-09-013", MUNICIPIO: "Comitán de Domínguez", MICROCUENCA: "La Floresta", REGION: "Meseta Comiteca", Priorizacion: 68, Clase_Priorizacion: "0.197223936836817", Categoria: "Muy Baja", Densidad_Poblacion: 0.35, Rezago_Social: -0.28, Sup_Microcuenca: 11632.4, Sup_Forestal: 4324.59, Sup_Pastizal: 204.93, Sup_Agricola: 2393.55, Sup_Asentamiento: 258.389999999999, Sup_Cafe: 0, Sup_Incendios: 0.15, Tiempo_Concentracion: 47.6, Pendiente: 18.39, Indice_Gravelius: 5.343, ETP: 73.8, Deforestacion: 0.86, Erosion: 5.29, Escurrimiento: 7.5, Precipitacion: 88.49 },
  { CODIGO: "30-126-02-001", MUNICIPIO: "Teopisca", MICROCUENCA: "Teopisca", REGION: "Altos ", Priorizacion: 69, Clase_Priorizacion: "0.196719955077678", Categoria: "Muy Baja", Densidad_Poblacion: 3.19, Rezago_Social: 1.26, Sup_Microcuenca: 9310.66, Sup_Forestal: 2924.90999999999, Sup_Pastizal: 371.79, Sup_Agricola: 2803.40999999999, Sup_Asentamiento: 788.129999999999, Sup_Cafe: 0, Sup_Incendios: 0.27, Tiempo_Concentracion: 44.53, Pendiente: 17.51, Indice_Gravelius: 2.126, ETP: 64, Deforestacion: 0.28, Erosion: 4.43, Escurrimiento: 7.71, Precipitacion: 94.2 },
  { CODIGO: "30-127-14-002", MUNICIPIO: "Ocozocoautla de Espinosa", MICROCUENCA: "Guadalupe Victoria (Londres)", REGION: "Valle Zoque", Priorizacion: 70, Clase_Priorizacion: "0.194687242916737", Categoria: "Muy Baja", Densidad_Poblacion: 0.69, Rezago_Social: 0.17, Sup_Microcuenca: 10084.63, Sup_Forestal: 6972.47999999999, Sup_Pastizal: 1207.71, Sup_Agricola: 1491.21, Sup_Asentamiento: 191.159999999999, Sup_Cafe: 1264.989, Sup_Incendios: 0, Tiempo_Concentracion: 41.1, Pendiente: 23.17, Indice_Gravelius: 2.765, ETP: 52.8, Deforestacion: 0.91, Erosion: 3.96, Escurrimiento: 7.5, Precipitacion: 100.01 },
  { CODIGO: "30-128-15-003", MUNICIPIO: "Comitán de Domínguez", MICROCUENCA: "Zaragoza La Montaña", REGION: "Meseta Comiteca", Priorizacion: 71, Clase_Priorizacion: "0.194175157761949", Categoria: "Muy Baja", Densidad_Poblacion: 0.4, Rezago_Social: -0.28, Sup_Microcuenca: 6517.34, Sup_Forestal: 3491.09999999999, Sup_Pastizal: 0, Sup_Agricola: 943.649999999999, Sup_Asentamiento: 103.68, Sup_Cafe: 0, Sup_Incendios: 0.6, Tiempo_Concentracion: 40.17, Pendiente: 16.04, Indice_Gravelius: 3.165, ETP: 85.5, Deforestacion: 0.52, Erosion: 7.24, Escurrimiento: 7.5, Precipitacion: 81.32 },
  { CODIGO: "30-128-18-007", MUNICIPIO: "La Trinitaria", MICROCUENCA: "Lázaro Cárdenas", REGION: "Meseta Comiteca", Priorizacion: 72, Clase_Priorizacion: "0.190432847065688", Categoria: "Muy Baja", Densidad_Poblacion: 1.7, Rezago_Social: 0.47, Sup_Microcuenca: 5482.1, Sup_Forestal: 753.299999999999, Sup_Pastizal: 278.639999999999, Sup_Agricola: 2678.67, Sup_Asentamiento: 247.86, Sup_Cafe: 29.907, Sup_Incendios: 2.01, Tiempo_Concentracion: 45.32, Pendiente: 9.92, Indice_Gravelius: 2.796, ETP: 59.2, Deforestacion: 0, Erosion: 2.33, Escurrimiento: 11.66, Precipitacion: 108.22 },
  { CODIGO: "30-127-12-010", MUNICIPIO: "Tuxtla Gutiérrez", MICROCUENCA: "El Jobo", REGION: "Metropolitana", Priorizacion: 73, Clase_Priorizacion: "0.187799712481272", Categoria: "Muy Baja", Densidad_Poblacion: 1.52, Rezago_Social: -1.07, Sup_Microcuenca: 4812.43, Sup_Forestal: 1543.04999999999, Sup_Pastizal: 397.709999999999, Sup_Agricola: 2512.61999999999, Sup_Asentamiento: 345.06, Sup_Cafe: 0, Sup_Incendios: 0, Tiempo_Concentracion: 43.89, Pendiente: 9.46, Indice_Gravelius: 2.247, ETP: 54.3, Deforestacion: 0.39, Erosion: 2.59, Escurrimiento: 9.06, Precipitacion: 85.4 },
  { CODIGO: "30-128-15-002", MUNICIPIO: "Comitán de Domínguez", MICROCUENCA: "Abelardo L. Rodríguez", REGION: "Meseta Comiteca", Priorizacion: 74, Clase_Priorizacion: "0.186264244919056", Categoria: "Muy Baja", Densidad_Poblacion: 0.35, Rezago_Social: -0.28, Sup_Microcuenca: 8311.13, Sup_Forestal: 4790.34, Sup_Pastizal: 0, Sup_Agricola: 1433.7, Sup_Asentamiento: 176.58, Sup_Cafe: 0, Sup_Incendios: 1.03, Tiempo_Concentracion: 41.67, Pendiente: 18.55, Indice_Gravelius: 2.16, ETP: 73, Deforestacion: 1.32, Erosion: 2.91, Escurrimiento: 7.5, Precipitacion: 87.54 },
  { CODIGO: "30-128-18-004", MUNICIPIO: "La Independencia", MICROCUENCA: "El Triunfo", REGION: "Meseta Comiteca", Priorizacion: 75, Clase_Priorizacion: "0.17945639830392", Categoria: "Muy Baja", Densidad_Poblacion: 1.23, Rezago_Social: 0.77, Sup_Microcuenca: 7368.86, Sup_Forestal: 1740.69, Sup_Pastizal: 722.519999999999, Sup_Agricola: 3998.96999999999, Sup_Asentamiento: 369.36, Sup_Cafe: 20.669, Sup_Incendios: 1.55, Tiempo_Concentracion: 57.9, Pendiente: 7.07, Indice_Gravelius: 3.398, ETP: 59.2, Deforestacion: 0.06, Erosion: 7.95, Escurrimiento: 33.17, Precipitacion: 96.48 },
  { CODIGO: "30-126-01-001", MUNICIPIO: "Teopisca", MICROCUENCA: "Betania", REGION: "Altos ", Priorizacion: 76, Clase_Priorizacion: "0.173274316962429", Categoria: "Muy Baja", Densidad_Poblacion: 3, Rezago_Social: 1.26, Sup_Microcuenca: 5138.82, Sup_Forestal: 1771.47, Sup_Pastizal: 122.31, Sup_Agricola: 1386.72, Sup_Asentamiento: 622.08, Sup_Cafe: 0, Sup_Incendios: 0.02, Tiempo_Concentracion: 33.92, Pendiente: 19.56, Indice_Gravelius: 4.594, ETP: 59.8, Deforestacion: 0.1, Erosion: 4.21, Escurrimiento: 7.5, Precipitacion: 97.59 },
  { CODIGO: "30-127-04-011", MUNICIPIO: "Cintalapa", MICROCUENCA: "Adolfo López Mateos", REGION: "Valle Zoque", Priorizacion: 77, Clase_Priorizacion: "0.163008988938205", Categoria: "Muy Baja", Densidad_Poblacion: 0.26, Rezago_Social: -0.14, Sup_Microcuenca: 13080.57, Sup_Forestal: 10189.7999999999, Sup_Pastizal: 1777.14, Sup_Agricola: 928.259999999999, Sup_Asentamiento: 145.8, Sup_Cafe: 740.368, Sup_Incendios: 0, Tiempo_Concentracion: 46.06, Pendiente: 22.4, Indice_Gravelius: 2.605, ETP: 68.2, Deforestacion: 0.54, Erosion: 2.5, Escurrimiento: 11.64, Precipitacion: 106.93 },
  { CODIGO: "30-127-10-002", MUNICIPIO: "San Cristóbal de Las Casas", MICROCUENCA: "San Cristóbal De Las Casas", REGION: "Altos ", Priorizacion: 78, Clase_Priorizacion: "0.151548609759152", Categoria: "Muy Baja", Densidad_Poblacion: 17.16, Rezago_Social: -0.12, Sup_Microcuenca: 11098.38, Sup_Forestal: 6584.48999999999, Sup_Pastizal: 165.24, Sup_Agricola: 1931.03999999999, Sup_Asentamiento: 2258.28, Sup_Cafe: 0, Sup_Incendios: 1.24, Tiempo_Concentracion: 44.31, Pendiente: 21.05, Indice_Gravelius: 2.439, ETP: 66.4, Deforestacion: 0.37, Erosion: 3.09, Escurrimiento: 7.5, Precipitacion: 92.15 },
  { CODIGO: "30-127-08-001", MUNICIPIO: "San Fernando", MICROCUENCA: "San Fernando", REGION: "Metropolitana", Priorizacion: 79, Clase_Priorizacion: "0.139159182060951", Categoria: "Muy Baja", Densidad_Poblacion: 2.7, Rezago_Social: 0, Sup_Microcuenca: 12631.89, Sup_Forestal: 6821.81999999999, Sup_Pastizal: 1400.49, Sup_Agricola: 3602.88, Sup_Asentamiento: 727.379999999999, Sup_Cafe: 439.08, Sup_Incendios: 0.74, Tiempo_Concentracion: 49.95, Pendiente: 17.64, Indice_Gravelius: 2.969, ETP: 68.9, Deforestacion: 0.61, Erosion: 2.44, Escurrimiento: 10.21, Precipitacion: 89.79 }];



  const variables = [
  { key: 'MICROCUENCA', label: 'Por Microcuenca' },
  { key: 'Precipitacion', label: 'Precipitación (mm/mes)' },
  { key: 'Pendiente', label: 'Pendiente (%)' },
  { key: 'Densidad_Poblacion', label: 'Densidad de población (Hab/km²)' },
  { key: 'Rezago_Social', label: 'Rezago social' },
  { key: 'Sup_Microcuenca', label: 'Superficie microcuenca (ha)' },
  { key: 'Sup_Forestal', label: 'Superficie Forestal (ha)' },
  { key: 'Sup_Pastizal', label: 'Superficie Pastizal (ha)' },
  { key: 'Sup_Agricola', label: 'Superficie Agrícola (ha)' },
  { key: 'Sup_Asentamiento', label: 'Superficie Asentamientos (ha)' },
  { key: 'Sup_Cafe', label: 'Superficie Café (ha)' },
  { key: 'Sup_Incendios', label: 'Superficie incendios (ha)' },
  { key: 'Tiempo_Concentracion', label: 'Tiempo concentración (min)' },
  { key: 'Indice_Gravelius', label: 'Índice Gravelius' },
  { key: 'ETP', label: 'ETP (%)' },
  { key: 'Deforestacion', label: 'Deforestación (%)' },
  { key: 'Erosion', label: 'Erosión (Ton/Ha/año)' },
  { key: 'Escurrimiento', label: 'Escurrimiento (%)' },
  { key: 'Priorizacion', label: 'Priorización' },
  { key: 'Clase_Priorizacion', label: 'Clase Priorización' }];


  const filteredData = useMemo(() => {
    let data = allData.filter((item) =>
    (item.MICROCUENCA?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.MUNICIPIO?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.REGION?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.CODIGO?.toLowerCase() || '').includes(searchTerm.toLowerCase())
    );

    if (sortColumn) {
      data = [...data].sort((a, b) => {
        const aVal = a[sortColumn];
        const bVal = b[sortColumn];
        const direction = sortDirection === 'asc' ? 1 : -1;

        if (typeof aVal === 'string') {
          return aVal.localeCompare(bVal) * direction;
        }
        return (aVal - bVal) * direction;
      });
    }

    return data;
  }, [searchTerm, sortColumn, sortDirection]);

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const getValueColor = (value: number, type: string) => {
    if (type === 'erosion') {
      if (value > 15) return 'text-red-600 font-semibold';
      if (value > 10) return 'text-orange-600';
      if (value > 5) return 'text-yellow-600';
      return 'text-green-600';
    }
    if (type === 'deforestacion') {
      if (value > 100) return 'text-red-700 font-bold';
      if (value > 50) return 'text-red-600 font-semibold';
      if (value > 20) return 'text-orange-600';
      return 'text-green-600';
    }
    if (type === 'categoria') {
      if (value === 'Muy Alta') return 'text-red-500 font-bold';
      if (value === 'Alta') return 'text-orange-500';
      if (value === 'Media') return 'text-yellow-500';
      if (value === 'Baja') return 'text-green-500';
      return 'text-green-700';
    }
    return 'text-gray-700';
  };

  const varLabels: Record<string, string> = {
    Precipitacion: 'Precipitación (mm/mes)',
    Pendiente: 'Pendiente (%)',
    Densidad_Poblacion: 'Densidad de población (Hab/km²)',
    Rezago_Social: 'Rezago social',
    Sup_Microcuenca: 'Superficie microcuenca (ha)',
    Sup_Forestal: 'Superficie Forestal (ha)',
    Sup_Pastizal: 'Superficie Pastizal (ha)',
    Sup_Agricola: 'Superficie Agrícola (ha)',
    Sup_Asentamiento: 'Superficie Asentamientos (ha)',
    Sup_Cafe: 'Superficie Café (ha)',
    Sup_Incendios: 'Superficie incendios (ha)',
    Tiempo_Concentracion: 'Tiempo concentración (min)',
    Indice_Gravelius: 'Índice Gravelius',
    ETP: 'ETP (%)',
    Deforestacion: 'Deforestación (%)',
    Erosion: 'Erosión (Ton/Ha/año)',
    Escurrimiento: 'Escurrimiento (%)',
    Priorizacion: 'Priorización',
    Clase_Priorizacion: 'Clase Priorización'
  };

  const suggestions = useMemo(() => {
    if (!searchTerm.trim()) return [];

    const microcuencas = allData.
    map((item) => ({ type: 'microcuenca', value: item.MICROCUENCA, codigo: item.CODIGO })).
    filter((item) => item.value.toLowerCase().includes(searchTerm.toLowerCase()));

    const municipios = allData.
    map((item) => ({ type: 'municipio', value: item.MUNICIPIO })).
    filter((item, index, self) =>
    item.value.toLowerCase().includes(searchTerm.toLowerCase()) &&
    self.findIndex((t) => t.value === item.value) === index
    );

    return [...microcuencas, ...municipios].slice(0, 8);
  }, [searchTerm]);

  const exportToPDF = async () => {
    const doc = new jsPDF('landscape');
    let currentY = 20;

    // Portada
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(37, 99, 235);
    doc.text('Informe de Microcuencas - Chiapas', 14, currentY);
    currentY += 10;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(55, 65, 81);
    doc.text(`Resultados: ${filteredData.length} microcuencas`, 14, currentY);
    currentY += 6;
    if (searchTerm) {
      doc.text(`Filtro aplicado: "${searchTerm}"`, 14, currentY);
      currentY += 6;
    }
    doc.text(`Fecha: ${new Date().toLocaleDateString('es-MX')}`, 14, currentY);
    currentY += 15;

    // Tabla mejorada
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(31, 41, 55);
    doc.text('Datos de Microcuencas', 14, currentY);
    currentY += 5;

    const tableData = filteredData.slice(0, 15).map((row) => [
    row.CODIGO,
    row.MICROCUENCA,
    row.MUNICIPIO,
    row.REGION,
    row.Priorizacion,
    row.Categoria,
    row.Densidad_Poblacion?.toFixed(2),
    row.Rezago_Social?.toFixed(2),
    row.Sup_Microcuenca?.toFixed(2)]

    );

    autoTable(doc, {
      head: [['Código', 'Microcuenca', 'Municipio', 'Región', 'Prior.', 'Categoría', 'Densidad Poblacion (Hab/km²)', 'Rezago Social', 'Superficie (ha)']],
      body: tableData,
      startY: currentY,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2,
        lineColor: [200, 200, 200],
        lineWidth: 0.1
      },
      headStyles: {
        fillColor: [37, 99, 235],
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [249, 250, 251]
      },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 50 },
        2: { cellWidth: 45 },
        3: { cellWidth: 35 },
        4: { halign: 'center', cellWidth: 15 },
        5: { halign: 'center', cellWidth: 25 },
        6: { halign: 'right', cellWidth: 20 },
        7: { halign: 'right', cellWidth: 20 },
        8: { halign: 'right', cellWidth: 20 }
      }
    });

    // Agregar espacio entre tablas
    currentY = doc.lastAutoTable.finalY + 15;

    // Segunda tabla con variables adicionales
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(31, 41, 55);
    doc.text('Características Físico-Ambientales', 14, currentY);
    currentY += 5;

    // Crear los datos para la segunda tabla
    const tableData2 = filteredData.slice(0, 15).map((row) => [
    row.CODIGO || '',
    row.MICROCUENCA || '',
    (row.Sup_Forestal || 0)?.toFixed(2),
    (row.Sup_Pastizal || 0)?.toFixed(2),
    (row.Sup_Agricola || 0)?.toFixed(2),
    (row.Sup_Asentamiento || 0)?.toFixed(2),
    (row.Sup_Cafe || 0)?.toFixed(2),
    row.Sup_Incendios ? `${(row.Sup_Incendios || 0)?.toFixed(2)}%` : '0.00%',
    (row.Tiempo_Concentracion || 0)?.toFixed(2),
    (row.Pendiente || 0)?.toFixed(2),
    (row.Indice_Gravelius || 0)?.toFixed(2)]
    );

    autoTable(doc, {
      head: [
      [
      'Código',
      'Microcuenca',
      'Sup. Forestal (Ha)',
      'Sup. Pastizal (Ha)',
      'Sup. Agrícola (Ha)',
      'Sup. Asentamiento (Ha)',
      'Sup. Café (Ha)',
      'Sup. Incendios (%)',
      'Tiempo Conc. (min)',
      'Pendiente (%)',
      'Índice Gravelius']],


      body: tableData2,
      startY: currentY,
      theme: 'grid',
      styles: {
        fontSize: 7, // Un poco más pequeño para más columnas
        cellPadding: 1.5,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [16, 185, 129], // Color verde diferente para distinguir
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 8
      },
      alternateRowStyles: {
        fillColor: [243, 244, 246]
      },
      columnStyles: {
        0: { cellWidth: 20, halign: 'center' },
        1: { cellWidth: 40 },
        2: { cellWidth: 18, halign: 'right' },
        3: { cellWidth: 18, halign: 'right' },
        4: { cellWidth: 18, halign: 'right' },
        5: { cellWidth: 22, halign: 'right' },
        6: { cellWidth: 18, halign: 'right' },
        7: { cellWidth: 18, halign: 'right' },
        8: { cellWidth: 20, halign: 'right' },
        9: { cellWidth: 15, halign: 'right' },
        10: { cellWidth: 18, halign: 'right' }
      },
      margin: { left: 10, right: 10 }
    });

    // Si necesitas una tercera tabla con el resto de variables
    currentY = doc.lastAutoTable.finalY + 15;

    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(31, 41, 55);
    doc.text('Indicadores Hidrológicos y Sociales', 14, currentY);
    currentY += 5;

    // Tercera tabla con variables restantes
    const tableData3 = filteredData.slice(0, 15).map((row) => [
    row.CODIGO || '',
    row.MICROCUENCA || '',
    (row.Precipitacion || 0)?.toFixed(2),
    (row.ETP || 0)?.toFixed(2),
    (row.Deforestacion || 0)?.toFixed(2),
    (row.Erosion || 0)?.toFixed(2),
    (row.Escurrimiento || 0)?.toFixed(2),
    (row.Densidad_Poblacion || 0)?.toFixed(2),
    (row.Rezago_Social || 0)?.toFixed(2)]
    );

    autoTable(doc, {
      head: [
      [
      'Código',
      'Microcuenca',
      'Precipitación (mm/mes)',
      'ETP (%)',
      'Deforestación (%)',
      'Erosión (Ton/Ha/año)',
      'Escurrimiento (%)',
      'Densidad Pobl. (Hab/km²)',
      'Rezago Social']],


      body: tableData3,
      startY: currentY,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2,
        lineColor: [200, 200, 200],
        lineWidth: 0.1
      },
      headStyles: {
        fillColor: [139, 92, 246], // Color morado diferente
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [249, 250, 251]
      },
      columnStyles: {
        0: { cellWidth: 25, halign: 'center' },
        1: { cellWidth: 50 },
        2: { cellWidth: 22, halign: 'right' },
        3: { cellWidth: 22, halign: 'right' },
        4: { cellWidth: 22, halign: 'right' },
        5: { cellWidth: 22, halign: 'right' },
        6: { cellWidth: 22, halign: 'right' },
        7: { cellWidth: 22, halign: 'right' },
        8: { cellWidth: 20, halign: 'right' }
      }
    });

    // Nueva página para gráficas
    doc.addPage();
    currentY = 20;

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(37, 99, 235);
    doc.text('Gráficas de Análisis', 14, currentY);
    currentY += 10;

    // Capturar gráficas
    const charts = document.querySelectorAll('.bg-gradient-to-br');
    const chartElements = Array.from(charts).filter((el) =>
    el.querySelector('.recharts-wrapper')
    );

    for (let i = 0; i < Math.min(chartElements.length, 4); i++) {
      try {
        const canvas = await html2canvas(chartElements[i] as HTMLElement, {
          scale: 2,
          backgroundColor: '#ffffff'
        });

        const imgData = canvas.toDataURL('image/png');
        const imgWidth = 200;
        const imgHeight = canvas.height * imgWidth / canvas.width;

        if (i === 2) {
          doc.addPage();
          currentY = 20;
        }

        doc.addImage(imgData, 'PNG', 14, currentY, imgWidth, imgHeight);
        currentY += imgHeight + 10;

        if (i % 2 === 1 && i < chartElements.length - 1) {
          currentY = 20;
        }
      } catch (error) {
        console.error('Error capturando gráfica:', error);
      }
    }





    doc.save(`Informe_Microcuencas_${new Date().getTime()}.pdf`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <motion.header
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white shadow-lg border-b">

        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/')}
                className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors">

                <ArrowLeft className="w-5 h-5" />
                <span>Volver</span>
              </button>
              <div className="h-6 w-px bg-gray-300" />
              <div className="flex items-center space-x-3">
                <BarChart3 className="w-6 h-6 text-blue-600" />
                <h1 className="text-xl font-bold">Visualización de Datos - Microcuencas</h1>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button
                onClick={() => setShowVariablesInfo(true)}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors shadow-md">

                <Info className="w-4 h-4" />
                <span>Info Variables</span>
              </button>
              {/*
              <button
                onClick={() => setViewMode('charts')}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                viewMode === 'charts' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`
                }>

                <TrendingUp className="w-4 h-4" />
                <span>Gráficas</span>
              </button>
              <button
                onClick={() => setViewMode('table')}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                viewMode === 'table' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`
                }>

                <TableIcon className="w-4 h-4" />
                <span>Tabla</span>
              </button>
              */}
            </div>
          </div>
        </div>
      </motion.header>

      {/* Modal de Información de Variables */}
      {showVariablesInfo &&
      <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={() => setShowVariablesInfo(false)}>
          <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6 rounded-t-2xl flex items-center justify-between z-10">
              <div className="flex items-center gap-3">
                <Info className="w-8 h-8" />
                <div>
                  <h2 className="text-2xl font-bold">Información de Variables</h2>
                  <p className="text-sm opacity-90 mt-1">Descripción y unidades de medida</p>
                </div>
              </div>
              <button
              onClick={() => setShowVariablesInfo(false)}
              className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                  <h3 className="font-bold text-gray-900 mb-1">Precipitación</h3>
                  <p className="text-sm text-gray-600">Unidad: mm/mes</p>
                  <p className="text-xs text-gray-500 mt-2">Precipitación media mensual</p>
                </div>
                
                <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                  <h3 className="font-bold text-gray-900 mb-1">Pendiente</h3>
                  <p className="text-sm text-gray-600">Unidad: %</p>
                  <p className="text-xs text-gray-500 mt-2">Pendiente promedio del terreno</p>
                </div>
                
                <div className="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-500">
                  <h3 className="font-bold text-gray-900 mb-1">Densidad de Población</h3>
                  <p className="text-sm text-gray-600">Unidad: Hab/km²</p>
                  <p className="text-xs text-gray-500 mt-2">Habitantes por kilómetro cuadrado</p>
                </div>
                
                <div className="bg-yellow-50 rounded-lg p-4 border-l-4 border-yellow-500">
                  <h3 className="font-bold text-gray-900 mb-1">Rezago Social</h3>
                  <p className="text-sm text-gray-600">Unidad: Índice</p>
                  <p className="text-xs text-gray-500 mt-2">Índice de rezago social (CONEVAL)</p>
                </div>
                
                <div className="bg-cyan-50 rounded-lg p-4 border-l-4 border-cyan-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Microcuenca</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área total de la microcuenca</p>
                </div>
                
                <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Forestal</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área con cobertura forestal</p>
                </div>
                
                <div className="bg-amber-50 rounded-lg p-4 border-l-4 border-amber-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Pastizal</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área con pastizales</p>
                </div>
                
                <div className="bg-pink-50 rounded-lg p-4 border-l-4 border-pink-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Agrícola</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área destinada a agricultura</p>
                </div>
                
                <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Asentamientos</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área de asentamientos humanos</p>
                </div>
                
                <div className="bg-brown-50 rounded-lg p-4 border-l-4 border-brown-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Café</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área cultivada con café</p>
                </div>
                
                <div className="bg-rose-50 rounded-lg p-4 border-l-4 border-rose-500">
                  <h3 className="font-bold text-gray-900 mb-1">Superficie Incendios</h3>
                  <p className="text-sm text-gray-600">Unidad: ha</p>
                  <p className="text-xs text-gray-500 mt-2">Área afectada por incendios</p>
                </div>
                
                <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-500">
                  <h3 className="font-bold text-gray-900 mb-1">Tiempo de Concentración</h3>
                  <p className="text-sm text-gray-600">Unidad: min</p>
                  <p className="text-xs text-gray-500 mt-2">Tiempo que tarda el agua en llegar al punto de salida</p>
                </div>
                
                <div className="bg-indigo-50 rounded-lg p-4 border-l-4 border-indigo-500">
                  <h3 className="font-bold text-gray-900 mb-1">Índice Gravelius</h3>
                  <p className="text-sm text-gray-600">Unidad: Adimensional</p>
                  <p className="text-xs text-gray-500 mt-2">Índice de compacidad de la cuenca</p>
                </div>
                
                <div className="bg-teal-50 rounded-lg p-4 border-l-4 border-teal-500">
                  <h3 className="font-bold text-gray-900 mb-1">ETP</h3>
                  <p className="text-sm text-gray-600">Unidad: %</p>
                  <p className="text-xs text-gray-500 mt-2">Evapotranspiración potencial</p>
                </div>
                
                <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-500">
                  <h3 className="font-bold text-gray-900 mb-1">Deforestación</h3>
                  <p className="text-sm text-gray-600">Unidad: %</p>
                  <p className="text-xs text-gray-500 mt-2">Tasa de deforestación</p>
                </div>
                
                <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                  <h3 className="font-bold text-gray-900 mb-1">Erosión</h3>
                  <p className="text-sm text-gray-600">Unidad: Ton/Ha/año</p>
                  <p className="text-xs text-gray-500 mt-2">Tasa de erosión del suelo</p>
                </div>
                
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                  <h3 className="font-bold text-gray-900 mb-1">Escurrimiento</h3>
                  <p className="text-sm text-gray-600">Unidad: %</p>
                  <p className="text-xs text-gray-500 mt-2">Porcentaje de escurrimiento superficial</p>
                </div>
                
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-700">
                  <h3 className="font-bold text-gray-900 mb-1">Priorización</h3>
                  <p className="text-sm text-gray-600">Unidad: Orden (1-79)</p>
                  <p className="text-xs text-gray-500 mt-2">Orden de prioridad (1=mayor prioridad)</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      }

      {/* Modal de Detalle de Microcuenca */}
      {selectedMicrocuenca &&
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">

            <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6 rounded-t-xl flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold">{selectedMicrocuenca.MICROCUENCA}</h2>
                <p className="text-sm opacity-90 mt-1">Código: {selectedMicrocuenca.CODIGO} | Municipio: {selectedMicrocuenca.MUNICIPIO}</p>
              </div>
              <button
              onClick={() => setSelectedMicrocuenca(null)}
              className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors">

                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4">Variables Ambientales y Territoriales</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                  <div className="text-sm text-gray-600 mb-1">Priorización</div>
                  <div className={`text-2xl font-bold ${getValueColor(selectedMicrocuenca.Categoria, 'categoria')}`}>
                    {selectedMicrocuenca.Priorizacion?.toFixed(2)}
                  </div>
                </div>
                
                <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                  <div className="text-sm text-gray-600 mb-1">Categoría</div>
                  <div className={`text-2xl font-bold ${getValueColor(selectedMicrocuenca.Categoria, 'categoria')}`}>
                    {selectedMicrocuenca.Categoria}
                  </div>
                </div>

                <div className="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-500">
                  <div className="text-sm text-gray-600 mb-1">Densidad Población</div>
                  <div className="text-2xl font-bold text-purple-700">{selectedMicrocuenca.Densidad_Poblacion?.toFixed(2)} Hab/km²</div>
                </div>

                <div className="bg-yellow-50 rounded-lg p-4 border-l-4 border-yellow-500">
                  <div className="text-sm text-gray-600 mb-1">Rezago Social</div>
                  <div className="text-2xl font-bold text-yellow-700">{selectedMicrocuenca.Rezago_Social?.toFixed(2)}</div>
                </div>

                <div className="bg-cyan-50 rounded-lg p-4 border-l-4 border-cyan-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Microcuenca</div>
                  <div className="text-2xl font-bold text-cyan-700">{selectedMicrocuenca.Sup_Microcuenca?.toFixed(2)} ha</div>
                </div>

                <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Agrícola</div>
                  <div className="text-2xl font-bold text-green-700">{selectedMicrocuenca.Sup_Agricola?.toFixed(2)} ha</div>
                </div>

                <div className="bg-emerald-50 rounded-lg p-4 border-l-4 border-emerald-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Forestal</div>
                  <div className="text-2xl font-bold text-emerald-700">{selectedMicrocuenca.Sup_Forestal?.toFixed(2)} ha</div>
                </div>

                <div className="bg-amber-50 rounded-lg p-4 border-l-4 border-amber-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Pastizal</div>
                  <div className="text-2xl font-bold text-amber-700">{selectedMicrocuenca.Sup_Pastizal?.toFixed(2)} ha</div>
                </div>

                <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Asentamientos</div>
                  <div className="text-2xl font-bold text-orange-700">{selectedMicrocuenca.Sup_Asentamiento?.toFixed(2)} ha</div>
                </div>

                <div className="bg-brown-50 rounded-lg p-4 border-l-4 border-brown-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Café</div>
                  <div className="text-2xl font-bold text-brown-700">{selectedMicrocuenca.Sup_Cafe?.toFixed(3)} ha</div>
                </div>

                <div className="bg-rose-50 rounded-lg p-4 border-l-4 border-rose-500">
                  <div className="text-sm text-gray-600 mb-1">Superficie Incendios</div>
                  <div className="text-2xl font-bold text-rose-700">{selectedMicrocuenca.Sup_Incendios?.toFixed(2)} ha</div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-500">
                  <div className="text-sm text-gray-600 mb-1">Tiempo Concentración</div>
                  <div className="text-2xl font-bold text-gray-700">{selectedMicrocuenca.Tiempo_Concentracion?.toFixed(2)} min</div>
                </div>

                <div className="bg-pink-50 rounded-lg p-4 border-l-4 border-pink-500">
                  <div className="text-sm text-gray-600 mb-1">Pendiente</div>
                  <div className="text-2xl font-bold text-pink-700">{selectedMicrocuenca.Pendiente?.toFixed(2)} %</div>
                </div>

                <div className="bg-indigo-50 rounded-lg p-4 border-l-4 border-indigo-500">
                  <div className="text-sm text-gray-600 mb-1">Índice Gravelius</div>
                  <div className="text-2xl font-bold text-indigo-700">{selectedMicrocuenca.Indice_Gravelius?.toFixed(3)}</div>
                </div>

                <div className="bg-teal-50 rounded-lg p-4 border-l-4 border-teal-500">
                  <div className="text-sm text-gray-600 mb-1">ETP</div>
                  <div className="text-2xl font-bold text-teal-700">{selectedMicrocuenca.ETP?.toFixed(1)} %</div>
                </div>

                <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-500">
                  <div className="text-sm text-gray-600 mb-1">Deforestación</div>
                  <div className={`text-2xl font-bold ${getValueColor(selectedMicrocuenca.Deforestacion, 'deforestacion')}`}>
                    {selectedMicrocuenca.Deforestacion?.toFixed(2)} %
                  </div>
                </div>

                <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                  <div className="text-sm text-gray-600 mb-1">Erosión</div>
                  <div className={`text-2xl font-bold ${getValueColor(selectedMicrocuenca.Erosion, 'erosion')}`}>
                    {selectedMicrocuenca.Erosion?.toFixed(2)} Ton/Ha/año
                  </div>
                </div>

                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                  <div className="text-sm text-gray-600 mb-1">Escurrimiento</div>
                  <div className="text-2xl font-bold text-blue-700">{selectedMicrocuenca.Escurrimiento?.toFixed(2)} %</div>
                </div>

                <div className="bg-blue-100 rounded-lg p-4 border-l-4 border-blue-700">
                  <div className="text-sm text-gray-600 mb-1">Precipitación</div>
                  <div className="text-2xl font-bold text-blue-800">{selectedMicrocuenca.Precipitacion?.toFixed(2)} mm/mes</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      }

      <div className="container mx-auto px-6 py-8">
        {/* Barra de búsqueda y filtros */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-xl shadow-lg p-6 mb-6">

          <div className="flex items-start space-x-4 mb-4">
            <div className="flex-1 relative">
              <div className="flex items-center space-x-4">
                <Search className="w-5 h-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Buscar por microcuenca, municipio o código..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />

                <span className="text-sm text-gray-500 whitespace-nowrap">{filteredData.length} resultados</span>
              </div>
              
              {showSuggestions && suggestions.length > 0 &&
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="absolute top-full left-9 right-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-xl z-50 max-h-80 overflow-y-auto">

                  {suggestions.map((suggestion, index) =>
                <div
                  key={`${suggestion.type}-${suggestion.value}-${index}`}
                  onClick={() => {
                    setSearchTerm(suggestion.value);
                    setShowSuggestions(false);
                  }}
                  className="px-4 py-3 hover:bg-blue-50 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0">

                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <span className="font-semibold text-gray-800">{suggestion.value}</span>
                          {suggestion.type === 'microcuenca' &&
                      <span className="ml-2 text-xs text-gray-500">({(suggestion as any).codigo})</span>
                      }
                        </div>
                        <span className={`text-xs px-2 py-1 rounded-full ${
                    suggestion.type === 'microcuenca' ?
                    'bg-blue-100 text-blue-700' :
                    'bg-green-100 text-green-700'}`
                    }>
                          {suggestion.type === 'microcuenca' ? 'Microcuenca' : 'Municipio'}
                        </span>
                      </div>
                    </div>
                )}
                </motion.div>
              }
            </div>
            
            <div className="flex space-x-3">
              <div className="w-full max-w-sm">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Microcuenca

                </label>
                <select
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  className="w-full px-4 py-2 border-2 border-blue-300 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-800 font-medium shadow-sm hover:shadow-md transition-all">

                  <option value="">-- Seleccionar microcuenca --</option>
                  {allData.map((item) =>
                  <option key={`micro-${item.CODIGO}`} value={item.MICROCUENCA}>
                      {item.MICROCUENCA}
                    </option>
                  )}
                </select>
              </div>

              <div className="w-full max-w-sm">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Municipios
                </label>
                <select
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  className="w-full px-4 py-2 border-2 border-green-300 rounded-lg bg-gradient-to-br from-green-50 to-emerald-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 text-gray-800 font-medium shadow-sm hover:shadow-md transition-all">

                  <option value="">-- Seleccionar municipio --</option>
                  {Array.from(new Set(allData.map((item) => item.MUNICIPIO))).sort().map((municipio) =>
                  <option key={`muni-${municipio}`} value={municipio}>
                      {municipio}
                    </option>
                  )}
                </select>
              </div>

              <div className="w-full max-w-sm">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Región
                </label>
                <select
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  className="w-full px-4 py-2 border-2 border-purple-300 rounded-lg bg-gradient-to-br from-purple-50 to-pink-50 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-gray-800 font-medium shadow-sm hover:shadow-md transition-all">

                  <option value="">-- Seleccionar región --</option>
                  {Array.from(new Set(allData.map((item) => item.REGION))).sort().map((region) =>
                  <option key={`region-${region}`} value={region}>
                      {region}
                    </option>
                  )}
                </select>
              </div>
            </div>

            {(searchTerm || filteredData.length < allData.length) &&
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              onClick={exportToPDF}
              className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all shadow-lg hover:shadow-xl transform hover:scale-105">

                <FileDown className="w-4 h-4" />
                <span className="font-semibold">Exportar PDF</span>
              </motion.button>
            }
          </div>
        </motion.div>

        <div className="space-y-8">
          {/* Configuración de Gráficas */}


          {/* Tabla */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-white rounded-xl shadow-2xl overflow-hidden border-2 border-gray-200">

            <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
              <table className="w-full text-sm">
                <thead className="sticky top-0 z-40 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                  <tr>
                    {[
                    'CODIGO',
                    'MUNICIPIO',
                    'MICROCUENCA',
                    'REGION',
                    'Priorizacion',
                    'Categoria',
                    'Clase_Priorizacion',
                    'Densidad_Poblacion',
                    'Rezago_Social',
                    'Sup_Microcuenca',
                    'Sup_Forestal',
                    'Sup_Pastizal',
                    'Sup_Agricola',
                    'Sup_Asentamiento',
                    'Sup_Cafe',
                    'Sup_Incendios',
                    'Tiempo_Concentracion',
                    'Pendiente',
                    'Indice_Gravelius',
                    'ETP',
                    'Deforestacion',
                    'Erosion',
                    'Escurrimiento',
                    'Precipitacion'].
                    map((col, colIndex) =>
                    <th
                      key={col}
                      onClick={() => handleSort(col)}
                      className={`px-3 py-3 text-left font-semibold cursor-pointer hover:bg-blue-700 transition-colors whitespace-nowrap
                          ${colIndex < 3 ? 'sticky bg-gradient-to-r from-blue-600 to-indigo-600 z-30 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.3)]' : ''}
                        `}
                      style={
                      colIndex < 3 ? {
                        position: 'sticky',
                        left: colIndex === 0 ? '0' :
                        colIndex === 1 ? '69.9px' :
                        '165px',
                        top: '0' // ¡IMPORTANTE! Esto hace que se quede fijo también verticalmente

                      } : {}
                      }>

                        <div className="flex items-center space-x-1">
                          <span className="text-xs">
                            {col === 'Clase_Priorizacion' ? 'Clase Prior' :
                          col === 'Densidad_Poblacion' ? 'Dens Pob (Hab/km²)' :
                          col === 'Rezago_Social' ? 'Rez Social' :
                          col === 'Sup_Microcuenca' ? 'Sup total (ha)' :
                          col === 'Sup_Forestal' ? 'Sup Forestal (ha)' :
                          col === 'Sup_Pastizal' ? 'Sup Pastizal (ha)' :
                          col === 'Sup_Agricola' ? 'Sup Agrícola (ha)' :
                          col === 'Sup_Asentamiento' ? 'Sup Asent (ha)' :
                          col === 'Sup_Cafe' ? 'Sup Café (ha)' :
                          col === 'Sup_Incendios' ? 'Sup Incend (ha)' :
                          col === 'Tiempo_Concentracion' ? 'Tiempo Conc' :
                          col === 'Pendiente' ? 'Pendiente (%)' :
                          col === 'Indice_Gravelius' ? 'Índ Gravelius' :
                          col === 'Deforestacion' ? 'Deforest (%)' :
                          col === 'Erosion' ? 'Erosión (Ton/Ha/año)' :
                          col === 'Escurrimiento' ? 'Escurrimiento (%)' :
                          col === 'Precipitacion' ? 'Precip (mm/mes)' :
                          col}
                          </span>
                          {sortColumn === col && <span className="text-xs">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                        </div>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredData.map((row, index) =>
                  <motion.tr
                    key={row.CODIGO}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.02 }}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    className={`transition-all duration-200 ${
                    hoveredRow === index ?
                    'bg-blue-50 shadow-lg scale-[1.01] border-l-4 border-blue-500' :
                    index % 2 === 0 ?
                    'bg-white' :
                    'bg-gray-50'}`
                    }
                    onClick={() => setSelectedMicrocuenca(row)}>

                      <td className={`sticky left-0 px-3 py-2 font-medium text-gray-800 text-xs z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] ${
                    hoveredRow === index ? 'bg-blue-50' : index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`
                    } style={{ left: '0' }}>{row.CODIGO}</td>
                      <td className={`sticky px-3 py-2 text-gray-700 text-xs z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] ${
                    hoveredRow === index ? 'bg-blue-50' : index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`
                    } style={{ left: '69.9px' }}>{row.MUNICIPIO}</td>
                      <td className={`sticky px-3 py-2 font-semibold text-gray-900 text-xs z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] ${
                    hoveredRow === index ? 'bg-blue-50' : index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`
                    } style={{ left: '165px' }}>{row.MICROCUENCA}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs">{row.REGION}</td>
                      <td className="px-3 py-2 text-center">
                        <span className={`inline-flex items-center px-2 py-1 text-sm font-semibold rounded-full ${
                      row.Categoria === 'Muy Alta' ? 'bg-red-500 text-black-800' :
                      row.Categoria === 'Alta' ? 'bg-orange-500 text-black-800' :
                      row.Categoria === 'Media' ? 'bg-yellow-500 text-black-800' :
                      row.Categoria === 'Baja' ? 'bg-[#a6d96a] text-black-800' :
                      row.Categoria === 'Muy Baja' ? 'bg-[#1a9641] text-black-800' :
                      'bg-gray-100 text-gray-800'}`
                      }>
                          {row.Priorizacion}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-center">
                        <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full ${
                      row.Categoria === 'Muy Alta' ? 'bg-red-500 text-black-800' :
                      row.Categoria === 'Alta' ? 'bg-orange-500 text-black-800' :
                      row.Categoria === 'Media' ? 'bg-yellow-500 text-black-800' :
                      row.Categoria === 'Baja' ? 'bg-[#a6d96a] text-black-800' :
                      row.Categoria === 'Muy Baja' ? 'bg-[#1a9641] text-black-800' :
                      'bg-gray-100 text-gray-800'}`
                      }>
                          {row.Categoria}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{parseFloat(row.Clase_Priorizacion).toFixed(6)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Densidad_Poblacion?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Rezago_Social?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Microcuenca?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Forestal?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Pastizal?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Agricola?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Asentamiento?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Cafe?.toFixed(3)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Sup_Incendios?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Tiempo_Concentracion?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Pendiente?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Indice_Gravelius?.toFixed(3)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.ETP?.toFixed(1)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Deforestacion?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Erosion?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Escurrimiento?.toFixed(2)}</td>
                      <td className="px-3 py-2 text-gray-700 text-xs text-right">{row.Precipitacion?.toFixed(2)}</td>
                    </motion.tr>
                  )}
                </tbody>
              </table>
            </div>
          </motion.div>


          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg p-6">

            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <Filter className="w-4 h-4 text-gray-600" />
                <span className="font-medium text-gray-700">Configurar Gráficas (Seleccione una variable a visualizar):</span>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/*
                  <div>
                   <label className="block text-sm font-medium text-gray-700 mb-2">Variable Eje X (Dispersión):</label>
                   <select
                     value={selectedXVar}
                     onChange={(e) => setSelectedXVar(e.target.value)}
                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                      {variables.map((v) =>
                     <option key={v.key} value={v.key}>{v.label}</option>
                     )}
                   </select>
                  </div>
                  */
                }
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Variable Eje Y (Dispersión):</label>
                  <select
                    value={selectedYVar}
                    onChange={(e) => setSelectedYVar(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">

                    {variables.map((v) =>
                    <option key={v.key} value={v.key}>{v.label}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
          </motion.div>






          {/* Gráficas */}
          {/* Gráfica de dispersión interactiva */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border-2 border-blue-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-blue-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">
                {selectedXVar === 'MICROCUENCA' ? 'Por Microcuenca' : varLabels[selectedXVar]} vs {varLabels[selectedYVar]}
              </h2>
            </div>
            <ResponsiveContainer width="100%" height={400}>
              {selectedXVar === 'MICROCUENCA' ?
              <BarChart data={filteredData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                  <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                  <YAxis stroke="#475569" />
                  <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                  <Legend />
                  <Bar dataKey={selectedYVar} fill="#3b82f6" name={varLabels[selectedYVar]} radius={[8, 8, 0, 0]} />
                </BarChart> :
              selectedYVar === 'MICROCUENCA' ?
              <BarChart data={filteredData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                  <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                  <YAxis stroke="#475569" />
                  <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                  <Legend />
                  <Bar dataKey={selectedXVar} fill="#3b82f6" name={varLabels[selectedXVar]} radius={[8, 8, 0, 0]} />
                </BarChart> :

              <ScatterChart>
                  <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                  <XAxis type="number" dataKey={selectedXVar} name={varLabels[selectedXVar]} stroke="#475569" />
                  <YAxis type="number" dataKey={selectedYVar} name={varLabels[selectedYVar]} stroke="#475569" />
                  <Tooltip
                  cursor={{ strokeDasharray: '3 3' }}
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                  <Legend />
                  <Scatter name="Microcuencas" data={filteredData} fill="#3b82f6" />
                </ScatterChart>
              }
            </ResponsiveContainer>
          </motion.div>

          {/* Priorización */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 }}
            className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border-2 border-blue-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-blue-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">Priorización por Microcuenca</h2>
            </div>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={filteredData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                <YAxis stroke="#475569" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                <Legend />
                <Bar dataKey="Priorizacion" fill="#3b82f6" name="Priorización" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Erosión */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl shadow-lg p-6 border-2 border-red-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-red-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">Erosión (Ton/Ha/año)</h2>
            </div>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={filteredData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                <YAxis stroke="#475569" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                <Legend />
                <Bar dataKey="Erosion" fill="#ef4444" name="Erosión (Ton/Ha/año)" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Precipitación */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl shadow-lg p-6 border-2 border-blue-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-blue-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">Precipitación (mm/mes)</h2>
            </div>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={filteredData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                <YAxis stroke="#475569" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                <Legend />
                <Bar dataKey="Precipitacion" fill="#3b82f6" name="Precipitación (mm/mes)" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Uso de Suelo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl shadow-lg p-6 border-2 border-green-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-green-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">Uso de Suelo (ha)</h2>
            </div>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={filteredData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                <YAxis stroke="#475569" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                <Legend />
                <Bar dataKey="Sup_Agricola" fill="#e81267" name="Agrícola (ha)" radius={[8, 8, 0, 0]} />
                <Bar dataKey="Sup_Forestal" fill="#059669" name="Forestal (ha)" radius={[8, 8, 0, 0]} />
                <Bar dataKey="Sup_Pastizal" fill="#fbbf24" name="Pastizal (ha)" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Variables Sociales */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25 }}
            className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl shadow-lg p-6 border-2 border-purple-200">

            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-6 bg-purple-600 rounded"></div>
              <h2 className="text-lg font-bold text-gray-800">Variables Sociales</h2>
            </div>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={filteredData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
                <XAxis dataKey="MICROCUENCA" angle={-45} textAnchor="end" height={120} stroke="#475569" />
                <YAxis stroke="#475569" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', color: '#fff', borderRadius: '8px', border: 'none' }} />

                <Legend />
                <Bar dataKey="Densidad_Poblacion" fill="#8b5cf6" name="Densidad Población (Hab/km²)" radius={[8, 8, 0, 0]} />
                <Bar dataKey="Rezago_Social" fill="#ec4899" name="Rezago Social" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>
        </div>
      </div>
    </div>);

};

export default DataVisualization;